// // 'use client';

// // import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
// // import Link from 'next/link';
// // import useGetProducts from '~/hooks/useSearchProducts';
// // import useProductDisplayData from '~/hooks/useProductDisplayData';
// // import useProductCartActions from '~/hooks/useProductCartActions';
// // import { useDebounce } from 'ahooks';
// // import { useRouter } from 'next/navigation';
// // import { getShippingInfo } from '~/utilities/shippingInfo';
// // import { calculateBasePrice } from '~/utilities/basePriceCalculator';
// // import { getAvailability, getAddToCartLabel, resolveAvailabilityAttrs } from '~/utilities/availability';
// // import { createPortal } from 'react-dom';
// // import CategoryVariantSelector from '~/components/elements/products/modules/CategoryVariantSelector';
// // import {
// //     BellIcon,
// //     OutOfStockBadge,
// // } from '~/components/elements/products/modules/ProductParts';

// // const placeholderURL = '/static/img/products/rawento-product-placeholder.webp';

// // const formatPriceDE = (value) => {
// //     if (value === undefined || value === null || value === '' || value === '–') return '–';
// //     const num = typeof value === 'number' ? value : Number(String(value).replace(',', '.'));
// //     if (!Number.isFinite(num)) return '–';
// //     return new Intl.NumberFormat('de-DE', {
// //         minimumFractionDigits: 2,
// //         maximumFractionDigits: 2,
// //     }).format(num);
// // };

// // const normalizeShippingType = (raw) => {
// //     const s = String(raw || '').trim().toLowerCase();
// //     if (s === 'versand mit dhl paket') return 'Versand mit DHL Paket';
// //     if (s === 'lieferung durch spedition') return 'Lieferung durch Spedition';
// //     if (['digitaler versand', 'esd versand', 'esd'].includes(s)) return 'ESD Versand';
// //     return raw || 'Kostenloser Versand';
// // };

// // const getShippingLinkText = (shippingType) => {
// //     if (shippingType === 'Versand mit DHL Paket') return ' zzgl. Versand';
// //     if (shippingType === 'Lieferung durch Spedition') return ' zzgl. Spedition';
// //     if (shippingType === 'ESD Versand') return ' digitaler Versand';
// //     return null;
// // };

// // const getSearchWords = (raw) =>
// //     String(raw || '').trim().toLowerCase().split(/\s+/).filter(Boolean);

// // const isFuzzyWord = (word) => word.length >= 5 && !/\d/.test(word);

// // const maxTypos = (word) => (word.length >= 8 ? 2 : word.length >= 5 ? 1 : 0);

// // const editDistance = (a, b) => {
// //     const la = a.length;
// //     const lb = b.length;
// //     if (la === 0) return lb;
// //     if (lb === 0) return la;
// //     const d = Array.from({ length: la + 1 }, () => new Array(lb + 1).fill(0));
// //     for (let i = 0; i <= la; i += 1) d[i][0] = i;
// //     for (let j = 0; j <= lb; j += 1) d[0][j] = j;
// //     for (let i = 1; i <= la; i += 1) {
// //         for (let j = 1; j <= lb; j += 1) {
// //             const cost = a[i - 1] === b[j - 1] ? 0 : 1;
// //             d[i][j] = Math.min(
// //                 d[i - 1][j] + 1,
// //                 d[i][j - 1] + 1,
// //                 d[i - 1][j - 1] + cost
// //             );
// //             if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
// //                 d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
// //             }
// //         }
// //     }
// //     return d[la][lb];
// // };

// // const tokenize = (str) =>
// //     String(str || '').toLowerCase().split(/[^a-z0-9äöüß]+/).filter(Boolean);

// // const scoreWord = (word, title, sku) => {
// //     if (title.includes(word) || sku.includes(word)) return { score: 100, exact: true };
// //     if (!isFuzzyWord(word)) return { score: 0, exact: false };

// //     const tokens = [...tokenize(title), ...tokenize(sku)];
// //     let best = Infinity;
// //     for (let i = 0; i < tokens.length; i += 1) {
// //         const token = tokens[i];
// //         let dist = editDistance(word, token);
// //         if (token.length > word.length) {
// //             dist = Math.min(dist, editDistance(word, token.slice(0, word.length)));
// //         }
// //         if (dist < best) best = dist;
// //         if (best === 0) break;
// //     }
// //     if (best <= maxTypos(word)) return { score: 70 - best * 10, exact: false };
// //     return { score: 0, exact: false };
// // };

// // const dropdownBorderColor = '#d9dbe0';
// // const dropdownBorderStyle = `1px solid ${dropdownBorderColor}`;

// // const discountBadgeStyle = {
// //     borderRadius: '3px',
// //     background: 'rgb(255, 255, 255)',
// //     border: '1px solid rgb(250, 207, 207)',
// //     display: 'inline-flex',
// //     alignItems: 'center',
// //     padding: '2px 6px',
// //     width: 'fit-content',
// //     fontSize: '15px',
// //     lineHeight: '16px',
// //     fontWeight: 500,
// //     color: 'rgb(216, 34, 34)',
// //     boxSizing: 'border-box',
// //     letterSpacing: '0.4px',
// //     whiteSpace: 'nowrap',
// //     flexShrink: 0,
// // };

// // const closeBarStyle = {
// //     display: 'flex',
// //     justifyContent: 'flex-end',
// //     alignItems: 'center',
// //     width: '100%',
// //     padding: '4px 12px 0 12px',
// //     boxSizing: 'border-box',
// // };

// // const closeButtonStyle = {
// //     border: 'none',
// //     outline: 'none',
// //     background: 'transparent',
// //     cursor: 'pointer',
// //     fontSize: '22px',
// //     lineHeight: 1,
// //     color: '#444',
// //     width: '32px',
// //     height: '32px',
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //     borderRadius: '9999px',
// //     flexShrink: 0,
// //     padding: 0,
// // };

// // const productCardBorderGray = '#e4e6ea';

// // const productCardStyle = {
// //     marginRight: 0,
// //     textDecoration: 'none',
// //     padding: '8px',
// //     backgroundColor: '#ffffff',
// //     border: `1px solid ${productCardBorderGray}`,
// //     borderRadius: '8px',
// //     gap: '4px',
// //     display: 'flex',
// //     flexDirection: 'column',
// //     height: 'auto',
// //     position: 'relative',
// //     minWidth: 0,
// //     overflow: 'hidden',
// //     boxSizing: 'border-box',
// // };

// // const productImageWrapStyle = {
// //     backgroundColor: 'transparent',
// //     borderRadius: '6px',
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'center',
// //     width: '100%',
// //     height: '110px',
// //     overflow: 'hidden',
// // };

// // const productsGridStyle = {
// //     display: 'grid',
// //     gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
// //     gap: '20px',
// //     width: '100%',
// // };

// // const SMALL_BOX_HEIGHT = 260;

// // const POPULAR_SEARCHES = [
// //     'Windows 11',
// //     'Microsoft Office',
// //     'Antivirus',
// //     'Notebook',
// //     'Monitor',
// //     'Gaming PC',
// //     'Tastatur',
// //     'SSD',
// //     'Grafikkarte',
// //     'Router',
// //     'Kopfhörer',
// //     'Maus',
// // ];

// // const popularTitleStyle = {
// //     fontSize: '14px',
// //     fontWeight: 700,
// //     color: '#2f3134',
// //     letterSpacing: '0.4px',
// //     margin: '0 0 12px 0',
// // };

// // const popularTagStyle = {
// //     border: '1px solid transparent',
// //     borderRadius: '9999px',
// //     padding: '8px 16px',
// //     fontSize: '14px',
// //     lineHeight: '20px',
// //     color: '#111111',
// //     cursor: 'pointer',
// //     whiteSpace: 'nowrap',
// // };

// // const rwSpinnerKeyframes = (
// //     <style>{`
// //         .rw-spinner {
// //             border: 2px solid rgba(45, 70, 105, 0.15);
// //             border-top-color: var(--rw-spinner-color, #2D4669);
// //             border-radius: 50%;
// //             display: block;
// //             width: var(--rw-spinner-size, 20px);
// //             height: var(--rw-spinner-size, 20px);
// //             animation: rw-spinner-rotate 0.7s linear infinite;
// //         }
// //         @keyframes rw-spinner-rotate {
// //             to { transform: rotate(360deg); }
// //         }

// //         .rw-variant-wrap {
// //             height: auto;
// //             min-height: 0;
// //             max-height: none;
// //             width: 100%;
// //             box-sizing: border-box;
// //             overflow: visible;
// //             margin: 2px 0;
// //         }

// //         .rw-cart-row {
// //             width: 100%;
// //             max-width: 100%;
// //             box-sizing: border-box;
// //             display: flex;
// //             justify-content: flex-end;
// //             align-items: center;
// //             margin-top: auto;
// //             padding-top: 6px;
// //         }
// //         .rw-cart-btn {
// //             display: inline-flex;
// //             align-items: center;
// //             justify-content: flex-end;
// //             gap: 5px;
// //             padding: 0;
// //             border: 0;
// //             background: transparent;
// //             color: #111;
// //             font-size: 12px;
// //             font-weight: 700;
// //             line-height: 1;
// //             cursor: pointer;
// //             white-space: nowrap;
// //             align-self: flex-end;
// //             max-width: 100%;
// //         }
// //         .rw-cart-btn:hover { color: #06c; }
// //         .rw-cart-btn--success, .rw-cart-btn--success:hover { color: #0e813a; }
// //         .rw-cart-btn__text { text-decoration: underline; overflow: hidden; text-overflow: ellipsis; flex-shrink: 0; }
// //         .rw-cart-btn--success .rw-cart-btn__text { text-decoration: none; flex-shrink: 1; }
// //         .rw-cart-btn__icon { display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; }
// //         .rw-cart-btn__icon svg { width: 20px; height: 15px; display: block; }
// //         .rw-availability { align-self: flex-end; max-width: 100%; margin-top: 5px; }
// //     `}</style>
// // );

// // const SpinnerIcon = ({ size = 20, color = '#2D4669' }) => (
// //     <span
// //         className="rw-spinner"
// //         style={{ '--rw-spinner-size': `${size}px`, '--rw-spinner-color': color }}
// //     />
// // );

// // const SearchProductCard = ({ product, apiBaseUrl, toggleSlideIn, onOverlayChange }) => {
// //     const [selectedVariant, setSelectedVariant] = useState(null);

// //     const activeSource = selectedVariant?.attributes || product.attributes;

// //     const {
// //         productId,
// //         plainProductTitle,
// //         numericPrice,
// //         isAvailable,
// //         hasStockInfo,
// //     } = useProductDisplayData(product, selectedVariant);

// //     const availability = useMemo(
// //         () =>
// //             getAvailability(
// //                 resolveAvailabilityAttrs(
// //                     product.attributes,
// //                     selectedVariant?.attributes || null
// //                 ),
// //                 activeSource?.shippings?.data?.attributes ||
// //                     product.attributes?.shippings?.data?.attributes ||
// //                     null
// //             ),
// //         [activeSource, selectedVariant, product]
// //     );
// //     const canOrder = availability.status === 'preorder' ? true : isAvailable;
// //     const addToCartLabel = getAddToCartLabel(availability);

// //     const { handleAddToCart, openNotifyModal, notifyModal, notifySuccessMessage } = useProductCartActions({
// //         productId,
// //         productTitle: plainProductTitle,
// //         productPrice: numericPrice,
// //     });

// //     const isNotifyModalOpen = Boolean(notifyModal);
// //     useEffect(() => {
// //         onOverlayChange?.(isNotifyModalOpen);
// //         return () => onOverlayChange?.(false);
// //     }, [isNotifyModalOpen, onOverlayChange]);

// //     const productSlug = product.attributes?.slug || product.id;
// //     const productTitle = activeSource?.title || product.attributes?.title || product.attributes?.sku || 'Produkt';

// //     const imageUrl = activeSource?.base_image_thumbnail;
// //     const finalImageSrc = imageUrl ? `${apiBaseUrl}/images/${imageUrl}` : placeholderURL;

// //     const rawPrice = activeSource?.price;
// //     const price = formatPriceDE(rawPrice);
// //     const currentPrice = rawPrice != null ? Number(rawPrice) : null;

// //     const lowest30d = activeSource?.lowestPrice30d ?? null;
// //     const showReduction =
// //         lowest30d !== null &&
// //         currentPrice !== null &&
// //         Number(lowest30d) > currentPrice;
// //     const bestPrice30d = formatPriceDE(lowest30d);

// //     const discountPercent = showReduction
// //         ? (((Number(lowest30d) - currentPrice) / Number(lowest30d)) * 100).toFixed(0)
// //         : null;

// //     const taxRate = activeSource?.taxes?.data?.attributes?.tax_rate;
// //     const taxAndShippingInfo = taxRate !== undefined && taxRate !== null ? 'inkl. MwSt.' : 'MwSt. nicht angegeben';

// //     const rawShipping = activeSource?.shippings?.data?.attributes?.shipping_type;
// //     const shippingType = normalizeShippingType(rawShipping);
// //     const shippingLinkText = getShippingLinkText(shippingType);
// //     const shouldShowShippingLink = shippingLinkText !== null;

// //     const baseprice_product_amount = product.attributes?.baseprice_product_amount;
// //     const baseprice_product_unit = product.attributes?.baseprice_product_unit;
// //     const baseprice_reference_amount = product.attributes?.baseprice_reference_amount;
// //     const baseprice_reference_unit = product.attributes?.baseprice_reference_unit;

// //     const basePricePerUnit = calculateBasePrice(
// //         rawPrice,
// //         baseprice_product_amount,
// //         baseprice_product_unit,
// //         baseprice_reference_amount,
// //         baseprice_reference_unit
// //     );

// //     const energyEfficiencyImage = activeSource?.energy_efficiencies?.data?.attributes?.energy_efficiency_image;
// //     const energyEfficiencyLabelUrl = activeSource?.energy_efficiency_label
// //         ? `${apiBaseUrl}/${activeSource.energy_efficiency_label}`
// //         : null;
// //     const energyEfficiencyDatasheetUrl = activeSource?.energy_efficiency_datasheet
// //         ? `${apiBaseUrl}/${activeSource.energy_efficiency_datasheet}`
// //         : null;

// //     return (
// //         <div style={productCardStyle}>
// //             <a href={`/product/${productSlug}`} style={{ color: 'rgb(12, 25, 58)', textDecoration: 'none', display: 'block', position: 'relative' }}>
// //                 <div style={productImageWrapStyle}>
// //                     <img
// //                         src={finalImageSrc}
// //                         alt={productTitle}
// //                         style={{ objectFit: 'contain', width: '110px', height: '96px', maxWidth: '100%', display: 'block', mixBlendMode: 'multiply' }}
// //                         onError={(e) => { e.target.src = placeholderURL; }}
// //                     />
// //                 </div>
// //                 {discountPercent !== null && (
// //                     <div data-testid="product-tag" className="ps-product__discount-badge" style={{ ...discountBadgeStyle, position: 'absolute', top: '4px', left: '4px' }}>
// //                         -{discountPercent}%
// //                     </div>
// //                 )}
// //             </a>

// //             <p style={{ lineHeight: '16px', fontWeight: '400', fontSize: '12px', width: '100%', height: '34px', WebkitLineClamp: 2, overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical', margin: '4px 0 0 0' }}>
// //                 <Link href={`/product/${productSlug}`} style={{ color: 'rgb(12, 25, 58)', textDecoration: 'none', display: 'block' }}>
// //                     {productTitle}
// //                 </Link>
// //             </p>

// //             {energyEfficiencyImage && (
// //                 <div style={{ display: 'flex', flexDirection: 'column', marginTop: '2px', width: '100%' }}>
// //                     <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', gap: '4px', maxWidth: '100%' }}>
// //                         {energyEfficiencyDatasheetUrl && (
// //                             <div
// //                                 onClick={() => window.open(energyEfficiencyDatasheetUrl, '_blank')}
// //                                 style={{ cursor: 'pointer', color: '#0073e6', fontSize: '10px', fontWeight: 'bold', textDecoration: 'underline', whiteSpace: 'nowrap', flexShrink: 0 }}
// //                             >
// //                                 Datenblatt
// //                             </div>
// //                         )}
// //                         <img
// //                             src={`${apiBaseUrl}${energyEfficiencyImage}`}
// //                             alt="Energy Efficiency"
// //                             style={{ cursor: 'pointer', maxWidth: '35px', maxHeight: '18px', width: 'auto', height: 'auto', flexShrink: 1, minWidth: '25px', display: 'block' }}
// //                             onClick={() => energyEfficiencyLabelUrl && window.open(energyEfficiencyLabelUrl, '_blank')}
// //                         />
// //                     </div>
// //                 </div>
// //             )}

// //             <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginTop: '4px', width: '100%' }}>
// //                 <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
// //                     <div style={{ fontWeight: '700', fontSize: '14px', lineHeight: '20px', color: showReduction ? '#bf0000' : '#000000', margin: 0, whiteSpace: 'nowrap', flexShrink: 0 }}>
// //                         {price}
// //                         <sup style={{ fontSize: '0.6em', fontWeight: 500, marginLeft: '1px' }}>€</sup>
// //                     </div>
// //                     {showReduction && (
// //                         <div style={{ fontSize: '12px', color: 'rgb(122, 117, 117)', fontWeight: '500', textDecoration: 'line-through', whiteSpace: 'nowrap', flexShrink: 0 }}>
// //                             {bestPrice30d}
// //                             <sup style={{ fontSize: '0.6em', fontWeight: 500, marginLeft: '1px' }}>€</sup>
// //                         </div>
// //                     )}
// //                 </div>

// //                 {basePricePerUnit && (
// //                     <div style={{ marginTop: '0px' }}>
// //                         <span style={{ fontSize: '10px', lineHeight: '14px', color: 'rgb(122, 117, 117)' }}>
// //                             {basePricePerUnit}
// //                             <sup style={{ fontSize: '0.6em', fontWeight: 500, marginLeft: '1px' }}>€</sup>
// //                             {' '}/ 1 {baseprice_reference_unit}
// //                         </span>
// //                     </div>
// //                 )}

// //                 {showReduction && (
// //                     <p style={{ fontSize: '10px', lineHeight: '14px', color: 'rgb(122, 117, 117)', margin: 0 }}>
// //                         30 Tage Bestpreis: {bestPrice30d}
// //                         <sup style={{ fontSize: '0.6em', fontWeight: 500, marginLeft: '1px' }}>€</sup>
// //                     </p>
// //                 )}
// //             </div>

// //             <div className="rw-variant-wrap">
// //                 <CategoryVariantSelector product={product} onVariantChange={setSelectedVariant} />
// //             </div>

// //             <div style={{ marginTop: '2px' }}>
// //                 <p style={{ color: 'rgb(80, 89, 113)', lineHeight: '15px', fontWeight: '400', fontSize: '11px', margin: 0 }}>
// //                     {taxAndShippingInfo}
// //                     {shouldShowShippingLink && (
// //                         <span
// //                             style={{ color: '#06c', cursor: 'pointer', fontSize: '11px' }}
// //                             onClick={() => toggleSlideIn(shippingType)}
// //                         >
// //                             {shippingLinkText}
// //                         </span>
// //                     )}
// //                 </p>
// //             </div>

// //             <div className="rw-cart-row">
// //                 {canOrder ? (
// //                     <button
// //                         type="button"
// //                         className="rw-cart-btn"
// //                         aria-label={addToCartLabel}
// //                         onClick={handleAddToCart}
// //                     >
// //                         <span className="rw-cart-btn__text">{addToCartLabel}</span>
// //                         <span aria-hidden="true" className="rw-cart-btn__icon">
// //                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 19" width="20" height="15" fill="none">
// //                                 <g stroke="currentColor">
// //                                     <path d="M1 1.5h4.2l4 8.8h10.4l3.8-8.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
// //                                     <circle cx="10.4" cy="15.5" r="1.8" strokeWidth="1.6" />
// //                                     <circle cx="20.2" cy="15.5" r="1.8" strokeWidth="1.6" />
// //                                 </g>
// //                             </svg>
// //                         </span>
// //                     </button>
// //                 ) : (
// //                     <button
// //                         type="button"
// //                         className={`rw-cart-btn${notifySuccessMessage ? ' rw-cart-btn--success' : ''}`}
// //                         aria-label={notifySuccessMessage ? 'Wir informieren Sie, sobald das Produkt verfügbar ist.' : 'Informiere mich...'}
// //                         title={notifySuccessMessage ? 'Wir informieren Sie, sobald das Produkt verfügbar ist.' : undefined}
// //                         onClick={openNotifyModal}
// //                     >
// //                         <span aria-hidden="true" className="rw-cart-btn__icon">
// //                             <BellIcon />
// //                         </span>
// //                         <span className="rw-cart-btn__text">
// //                             {notifySuccessMessage ? '✓ Wir informieren Sie' : 'Informiere mich...'}
// //                         </span>
// //                     </button>
// //                 )}
// //             </div>

// //             {hasStockInfo && !canOrder && (
// //                 <div className="rw-availability">
// //                     <OutOfStockBadge />
// //                 </div>
// //             )}

// //             {notifyModal}
// //         </div>
// //     );
// // };

// // const SearchHeader = ({ onSearchToggle }) => {
// //     const inputEl = useRef(null);
// //     const dropdownRef = useRef(null);
// //     const containerRef = useRef(null);
// //     const overlayOpenRef = useRef(false);
// //     const [keyword, setKeyword] = useState('');
// //     const [isFocused, setIsFocused] = useState(false);
// //     const [isDropdownClosed, setIsDropdownClosed] = useState(false);
// //     const [isSlideInVisible, setSlideInVisible] = useState(false);
// //     const [isSlideInAnimated, setSlideInAnimated] = useState(false);
// //     const [currentShippingType, setCurrentShippingType] = useState('');
// //     const { products, loading, getStrapiProducts, resetProducts, meta } = useGetProducts();
// //     const keywordDebounce = useDebounce(keyword, { wait: 300 });
// //     const router = useRouter();

// //     useEffect(() => {
// //         onSearchToggle?.((keyword !== '' && !isDropdownClosed) || isFocused);
// //     }, [keyword, isFocused, isDropdownClosed, onSearchToggle]);

// //     const containerHeight = 44;

// //     useEffect(() => {
// //         resetProducts();
// //     }, [keyword, resetProducts]);

// //     useEffect(() => {
// //         if (isSlideInVisible) {
// //             setSlideInAnimated(false);
// //             setTimeout(() => setSlideInVisible(false), 300);
// //         }
// //     }, [keyword]);

// //     function handleClearKeyword() {
// //         setKeyword('');
// //         setIsDropdownClosed(false);
// //         inputEl.current?.focus();
// //     }

// //     const closeDropdown = useCallback(() => {
// //         setIsDropdownClosed(true);
// //         setIsFocused(false);
// //         setSlideInAnimated(false);
// //         setSlideInVisible(false);
// //         inputEl.current?.blur();
// //     }, []);

// //     function handleSubmit(e) {
// //         e.preventDefault();
// //         closeDropdown();
// //         router.push(`/search?keyword=${encodeURIComponent(keyword)}`);
// //     }

// //     function handlePopularClick(term) {
// //         setKeyword('');
// //         setIsFocused(false);
// //         inputEl.current?.blur();
// //         router.push(`/search?keyword=${encodeURIComponent(term)}`);
// //     }

// //     const handleOverlayChange = useCallback((open) => {
// //         overlayOpenRef.current = Boolean(open);
// //     }, []);

// //     const handleClickOutside = useCallback((event) => {
// //         if (overlayOpenRef.current) return;
// //         if (containerRef.current && !containerRef.current.contains(event.target)) {
// //             setKeyword('');
// //             setIsFocused(false);
// //             setIsDropdownClosed(false);
// //         }
// //     }, []);

// //     useEffect(() => {
// //         if (keyword.length > 0 || isFocused) {
// //             document.addEventListener('mousedown', handleClickOutside);
// //             return () => document.removeEventListener('mousedown', handleClickOutside);
// //         }
// //     }, [keyword.length, isFocused, handleClickOutside]);

// //     const toggleSlideIn = useCallback((shippingType) => {
// //         setCurrentShippingType(shippingType);
// //         if (isSlideInVisible) {
// //             setSlideInAnimated(false);
// //             setTimeout(() => setSlideInVisible(false), 500);
// //         } else {
// //             setSlideInVisible(true);
// //             requestAnimationFrame(() => {
// //                 requestAnimationFrame(() => {
// //                     setSlideInAnimated(true);
// //                 });
// //             });
// //         }
// //     }, [isSlideInVisible]);

// //     useEffect(() => {
// //         if (isSlideInVisible) {
// //             document.body.style.overflow = 'hidden';
// //         } else {
// //             document.body.style.overflow = '';
// //         }
// //         const handleEscape = (event) => {
// //             if (event.key === 'Escape' && isSlideInVisible) {
// //                 toggleSlideIn(currentShippingType);
// //             }
// //         };
// //         document.addEventListener('keydown', handleEscape);
// //         return () => {
// //             document.body.style.overflow = '';
// //             document.removeEventListener('keydown', handleEscape);
// //         };
// //     }, [isSlideInVisible, currentShippingType, toggleSlideIn]);

// //     const searchQuery = useMemo(() => {
// //         if (keywordDebounce.trim().length > 2) {
// //             const words = getSearchWords(keywordDebounce);
// //             const hasFuzzy = words.some(isFuzzyWord);

// //             const wordFilters = words.map((word) => {
// //                 const orFilters = [
// //                     { title: { $containsi: word } },
// //                     { sku: { $containsi: word } },
// //                 ];

// //                 if (isFuzzyWord(word)) {
// //                     const fragLength = Math.max(3, Math.ceil(word.length / 2));
// //                     const head = word.slice(0, fragLength);
// //                     const tail = word.slice(-fragLength);
// //                     orFilters.push(
// //                         { title: { $containsi: head } },
// //                         { sku: { $containsi: head } },
// //                         { title: { $containsi: tail } },
// //                         { sku: { $containsi: tail } }
// //                     );
// //                 }

// //                 return { $or: orFilters };
// //             });

// //             const query = {
// //                 filters: {
// //                     $and: [
// //                         ...wordFilters,
// //                         { visibility: { $eq: 'Katalog, Suche' } }
// //                     ]
// //                 },
// //                 populate: {
// //                     taxes: { fields: ['summary', 'tax_rate'] },
// //                     shippings: true,
// //                     product_categories: { fields: ['title', 'slug'] },
// //                     product_typs: { fields: ['title', 'slug'] },
// //                     product_brands: { fields: ['manufacturer_url'] },
// //                     energy_efficiencies: { fields: ['energy_efficiency_class', 'energy_efficiency_image'] },
// //                     product_variants: {
// //                         populate: {
// //                             facet_inputs: {
// //                                 fields: ['title'],
// //                                 populate: 'facets',
// //                             },
// //                             taxes: {
// //                                 fields: ['summary', 'tax_rate'],
// //                             },
// //                             shippings: true,
// //                             energy_efficiencies: {
// //                                 fields: [
// //                                     'energy_efficiency_class',
// //                                     'energy_efficiency_image',
// //                                 ],
// //                             },
// //                             product_typs: {
// //                                 fields: ['title', 'slug'],
// //                             },
// //                         },
// //                     },
// //                 },
// //                 sort: ['order:asc', 'title:asc'],
// //                 pagination: { pageSize: hasFuzzy ? 100 : 40 },
// //             };
// //             return query;
// //         }
// //         return null;
// //     }, [keywordDebounce]);

// //     useEffect(() => {
// //         if (searchQuery) {
// //             getStrapiProducts(searchQuery, 'search');
// //         }
// //     }, [searchQuery, getStrapiProducts]);

// //     const totalSearchResults = useMemo(() => {
// //         if (loading || !meta?.pagination) return 0;
// //         return meta.pagination.total || 0;
// //     }, [meta?.pagination, loading]);

// //     // Das Backend entscheidet, welche Produkte Treffer sind.
// //     // Das Scoring sortiert nur noch, es filtert nichts mehr heraus.
// //     const scoredResults = useMemo(() => {
// //         if (loading || keyword.trim().length === 0) return [];
// //         const words = getSearchWords(keyword);
// //         if (words.length === 0) return [];

// //         return (products || [])
// //             .map((product, index) => {
// //                 const title = (product.attributes?.title || '').toLowerCase();
// //                 const sku = (product.attributes?.sku || '').toLowerCase();

// //                 let total = 0;
// //                 for (let i = 0; i < words.length; i += 1) {
// //                     total += scoreWord(words[i], title, sku).score;
// //                 }
// //                 let score = total / words.length;

// //                 const titleTokens = tokenize(title);
// //                 if (title.startsWith(words[0])) score += 30;
// //                 else if (titleTokens.includes(words[0])) score += 15;

// //                 return { product, score, index };
// //             })
// //             .sort((a, b) => b.score - a.score || a.index - b.index)
// //             .slice(0, 8);
// //     }, [products, loading, keyword]);

// //     const resultProducts = useMemo(
// //         () => scoredResults.map(({ product }) => product),
// //         [scoredResults]
// //     );

// //     const hasResults = resultProducts.length > 0;
// //     const isTooShort = keyword.length > 0 && keyword.length < 3;
// //     const isSearchPending = keyword.length >= 3 && keywordDebounce !== keyword;
// //     const rawShowLoadingBox = keyword.length >= 3 && (loading || isSearchPending);
// //     const rawShowNoResults = keyword.length >= 3 && !rawShowLoadingBox && !hasResults;

// //     const [confirmedNoResults, setConfirmedNoResults] = useState(false);
// //     useEffect(() => {
// //         if (rawShowNoResults) {
// //             const timer = setTimeout(() => setConfirmedNoResults(true), 250);
// //             return () => clearTimeout(timer);
// //         }
// //         setConfirmedNoResults(false);
// //         return undefined;
// //     }, [rawShowNoResults, keywordDebounce]);

// //     const showNoResults = confirmedNoResults;
// //     const showLoadingBox = rawShowLoadingBox || (rawShowNoResults && !confirmedNoResults);
// //     const showDropdown =
// //         !isDropdownClosed &&
// //         keyword.length > 0 &&
// //         (showLoadingBox || hasResults || showNoResults || isTooShort);

// //     const showPopular = isFocused && keyword.length === 0;

// //     const shippingInfoText = useMemo(() => {
// //         return getShippingInfo(currentShippingType);
// //     }, [currentShippingType]);

// //     const slideInPortal = isSlideInVisible && typeof window !== 'undefined'
// //         ? createPortal(
// //             <>
// //                 <div
// //                     className={`rw-slidein-overlay rw-slidein-overlay--top ${isSlideInAnimated ? 'open' : ''}`}
// //                     onClick={() => toggleSlideIn(currentShippingType)}
// //                 />
// //                 <div className={`rw-slidein rw-slidein--top ${isSlideInAnimated ? 'open' : ''}`}>
// //                     <div className="rw-slidein__header">
// //                         <h3 className="rw-slidein__title">Versandinformationen</h3>
// //                         <button
// //                             type="button"
// //                             className="rw-slidein__close"
// //                             onClick={() => toggleSlideIn(currentShippingType)}
// //                             aria-label="Schließen"
// //                         >
// //                             ×
// //                         </button>
// //                     </div>
// //                     <div className="rw-slidein__body">{shippingInfoText}</div>
// //                 </div>
// //             </>,
// //             document.body
// //         )
// //         : null;

// //     const quickSearchBox = useMemo(() => {
// //         if (!showDropdown) return null;

// //         if (isTooShort) {
// //             const remaining = 3 - keyword.length;
// //             return (
// //                 <div ref={dropdownRef} className="search-results-dropdown absolute z-[60000] top-full left-1/2 -translate-x-1/2 w-[50vw] max-w-md bg-white shadow-2xl rounded-xl mt-px text-center relative overflow-hidden" style={{ minHeight: `${SMALL_BOX_HEIGHT}px`, display: 'flex', flexDirection: 'column', border: dropdownBorderStyle }}>
// //                     <div style={{ ...closeBarStyle, padding: '4px 0 0 0' }}>
// //                         <button
// //                             type="button"
// //                             onClick={handleClearKeyword}
// //                             style={closeButtonStyle}
// //                             className="hover:bg-gray-100 transition-all duration-200"
// //                         >
// //                             ×
// //                         </button>
// //                     </div>

// //                     <div className="px-6" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '28px' }}>
// //                         <div style={{
// //                             width: '48px',
// //                             height: '48px',
// //                             borderRadius: '50%',
// //                             background: 'linear-gradient(135deg, #eef2f7 0%, #e4e9f0 100%)',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             justifyContent: 'center',
// //                             margin: '0 auto 16px',
// //                         }}>
// //                             <i className="icon-magnifier" style={{ fontSize: '20px', color: '#2D4669' }} />
// //                         </div>

// //                         <p style={{
// //                             fontSize: '14px',
// //                             fontWeight: 600,
// //                             color: '#2f3134',
// //                             margin: '0 0 6px',
// //                         }}>
// //                             Noch {remaining === 1 ? 'ein Zeichen' : `${remaining} Zeichen`}
// //                         </p>
// //                         <p style={{
// //                             fontSize: '13px',
// //                             color: '#8a8f98',
// //                             margin: 0,
// //                             lineHeight: 1.5,
// //                         }}>
// //                             Gib mindestens 3 Zeichen ein, um die Suche zu starten.
// //                         </p>

// //                         <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', marginTop: '18px' }}>
// //                             {[0, 1, 2].map((i) => (
// //                                 <div
// //                                     key={i}
// //                                     style={{
// //                                         width: '7px',
// //                                         height: '7px',
// //                                         borderRadius: '50%',
// //                                         background: i < keyword.length ? '#2D4669' : '#e4e9f0',
// //                                         transition: 'background 0.25s ease',
// //                                     }}
// //                                 />
// //                             ))}
// //                         </div>
// //                     </div>
// //                 </div>
// //             );
// //         }

// //         if (showLoadingBox) {
// //             return (
// //                 <div ref={dropdownRef} className="search-results-dropdown absolute z-[60000] top-full left-1/2 -translate-x-1/2 w-[50vw] max-w-md bg-white shadow-2xl rounded-xl mt-px text-center relative overflow-hidden" style={{ minHeight: `${SMALL_BOX_HEIGHT}px`, display: 'flex', flexDirection: 'column', border: dropdownBorderStyle }}>
// //                     <div style={{ ...closeBarStyle, padding: '4px 0 0 0' }}>
// //                         <button
// //                             type="button"
// //                             onClick={handleClearKeyword}
// //                             style={closeButtonStyle}
// //                             className="hover:bg-gray-100 transition-all duration-200"
// //                         >
// //                             ×
// //                         </button>
// //                     </div>

// //                     <div className="px-6" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '28px' }}>
// //                         <div style={{
// //                             width: '48px',
// //                             height: '48px',
// //                             borderRadius: '50%',
// //                             background: 'linear-gradient(135deg, #eef2f7 0%, #e4e9f0 100%)',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             justifyContent: 'center',
// //                             margin: '0 auto 16px',
// //                         }}>
// //                             <SpinnerIcon size={20} color="#2D4669" />
// //                         </div>
// //                         <p style={{
// //                             fontSize: '14px',
// //                             fontWeight: 600,
// //                             color: '#2f3134',
// //                             margin: '0 0 6px',
// //                         }}>
// //                             Suchen
// //                         </p>
// //                         <p style={{
// //                             fontSize: '13px',
// //                             color: '#8a8f98',
// //                             margin: 0,
// //                             lineHeight: 1.5,
// //                         }}>
// //                             Wir durchsuchen unser Sortiment für dich.
// //                         </p>
// //                     </div>
// //                 </div>
// //             );
// //         }

// //         if (hasResults) {
// //             return (
// //                 <>
// //                     <div ref={dropdownRef} className="search-results-dropdown absolute z-[60000] top-full left-1/2 -translate-x-1/2 w-[50vw] max-w-[988px] bg-white rounded-[16px] overflow-hidden cursor-auto flex flex-col relative" style={{ border: dropdownBorderStyle }}>

// //                         <div style={closeBarStyle}>
// //                             <button
// //                                 type="button"
// //                                 onClick={handleClearKeyword}
// //                                 style={closeButtonStyle}
// //                                 className="hover:bg-gray-100 transition-all duration-200"
// //                             >
// //                                 ×
// //                             </button>
// //                         </div>

// //                         <div className="scrollbar-thin overflow-y-auto p-2 max-h-[calc(100vh-130px)]">
// //                             <div style={{ paddingTop: '8px', padding: '8px 16px 16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
// //                                 <div style={productsGridStyle}>
// //                                     {resultProducts.slice(0, 8).map((product) => (
// //                                         <SearchProductCard
// //                                             key={product.id}
// //                                             product={product}
// //                                             apiBaseUrl={process.env.NEXT_PUBLIC_FRONTEND_URL || 'http://localhost:1337'}
// //                                             toggleSlideIn={toggleSlideIn}
// //                                             onOverlayChange={handleOverlayChange}
// //                                         />
// //                                     ))}
// //                                 </div>
// //                             </div>
// //                         </div>

// //                         <div style={{ padding: '12px 16px', borderTop: '1px solid rgb(236, 237, 240)', backgroundColor: 'rgb(248, 250, 252)' }}>
// //                             <Link
// //                                 href={`/search?keyword=${encodeURIComponent(keyword)}`}
// //                                 onClick={closeDropdown}
// //                                 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '600', fontSize: '14px', padding: '12px 20px', backgroundColor: '#2D4669', color: 'white', textDecoration: 'none', width: '100%', height: '44px', borderRadius: '8px' }}
// //                             >
// //                                 {totalSearchResults > 0
// //                                     ? `Alle ${totalSearchResults.toLocaleString('de-DE')} Ergebnisse anzeigen`
// //                                     : `Zur Suche: "${keyword}"`}
// //                             </Link>
// //                         </div>
// //                     </div>

// //                     {slideInPortal}
// //                 </>
// //             );
// //         }

// //         if (showNoResults) {
// //             return (
// //                 <div ref={dropdownRef} className="search-results-dropdown absolute z-[60000] top-full left-1/2 -translate-x-1/2 w-[50vw] max-w-md bg-white shadow-2xl rounded-xl mt-px text-center relative overflow-hidden" style={{ minHeight: `${SMALL_BOX_HEIGHT}px`, display: 'flex', flexDirection: 'column', border: dropdownBorderStyle }}>
// //                     <div style={{ ...closeBarStyle, padding: '4px 0 0 0' }}>
// //                         <button
// //                             type="button"
// //                             onClick={handleClearKeyword}
// //                             style={closeButtonStyle}
// //                             className="hover:bg-gray-100 transition-all duration-200"
// //                         >
// //                             ×
// //                         </button>
// //                     </div>

// //                     <div className="px-6" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '28px' }}>
// //                         <div style={{
// //                             width: '48px',
// //                             height: '48px',
// //                             borderRadius: '50%',
// //                             background: 'linear-gradient(135deg, #eef2f7 0%, #e4e9f0 100%)',
// //                             display: 'flex',
// //                             alignItems: 'center',
// //                             justifyContent: 'center',
// //                             margin: '0 auto 16px',
// //                         }}>
// //                             <i className="icon-magnifier" style={{ fontSize: '20px', color: '#2D4669' }} />
// //                         </div>

// //                         <p style={{
// //                             fontSize: '14px',
// //                             fontWeight: 600,
// //                             color: '#2f3134',
// //                             margin: '0 0 16px',
// //                         }}>
// //                             Keine Ergebnisse für "<strong>{keyword}</strong>" gefunden.
// //                         </p>

// //                         <Link
// //                             href={`/search?keyword=${encodeURIComponent(keyword)}`}
// //                             onClick={closeDropdown}
// //                             style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: '600', fontSize: '14px', padding: '12px 24px', backgroundColor: '#2D4669', color: 'white', textDecoration: 'none', borderRadius: '8px' }}
// //                         >
// //                             Zur Suchergebnisseite
// //                         </Link>
// //                     </div>
// //                 </div>
// //             );
// //         }

// //         return null;
// //     }, [resultProducts, keyword, showLoadingBox, handleClearKeyword, isSlideInVisible, currentShippingType, shippingInfoText, totalSearchResults, showDropdown, hasResults, showNoResults, isTooShort, toggleSlideIn, handleOverlayChange, slideInPortal, closeDropdown]);

// //     return (
// //         <div ref={containerRef} className="ps-search--mobile relative" style={{ height: `${containerHeight}px`, zIndex: isFocused || (keyword !== '' && !isDropdownClosed) ? 60001 : 'auto', position: 'relative' }}>
// //             {rwSpinnerKeyframes}
// //             <form className="ps-form--search-mobile h-full" action="/" method="get" onSubmit={handleSubmit}>
// //                 <div className="form-group--nest h-full flex items-center">
// //                     <input
// //                         ref={inputEl}
// //                         className="form-control flex-1 h-10"
// //                         type="text"
// //                         value={keyword}
// //                         placeholder="Suchen nach Marken, Artikeln & mehr..."
// //                         onFocus={() => {
// //                             setIsFocused(true);
// //                             setIsDropdownClosed(false);
// //                         }}
// //                         onChange={(e) => {
// //                             setKeyword(e.target.value);
// //                             setIsDropdownClosed(false);
// //                         }}
// //                     />
// //                     <button type="submit" aria-label="Suchen">
// //                         <i className="icon-magnifier" />
// //                     </button>
// //                 </div>
// //             </form>
// //             {loading && !isDropdownClosed && (
// //                 <span
// //                     className="ps-form__action absolute right-12 top-1/2 -translate-y-1/2"
// //                     style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
// //                 >
// //                     <SpinnerIcon size={16} color="#2D4669" />
// //                 </span>
// //             )}
// //             {quickSearchBox}

// //             {showPopular && (
// //                 <div
// //                     className="search-popular-dropdown absolute top-full left-0 w-full bg-white"
// //                     style={{
// //                         padding: '16px 20px 20px',
// //                         border: dropdownBorderStyle,
// //                         borderRadius: '16px',
// //                         boxShadow: '0 12px 32px rgba(0,0,0,0.12)',
// //                         zIndex: 60000,
// //                     }}
// //                 >
// //                     <p style={popularTitleStyle}>Beliebte Suchanfragen</p>
// //                     <ul style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', listStyle: 'none', margin: 0, padding: 0 }}>
// //                         {POPULAR_SEARCHES.map((term) => (
// //                             <li key={term}>
// //                                 <button
// //                                     type="button"
// //                                     onClick={() => handlePopularClick(term)}
// //                                     className="bg-[#f4f5fa] hover:bg-[#e6e8f1] transition-colors duration-150"
// //                                     style={popularTagStyle}
// //                                 >
// //                                     {term}
// //                                 </button>
// //                             </li>
// //                         ))}
// //                     </ul>
// //                 </div>
// //             )}
// //         </div>
// //     );
// // };

// // export default SearchHeader;


// 'use client';

// import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
// import Link from 'next/link';
// import useGetProducts from '~/hooks/useSearchProducts';
// import useProductDisplayData from '~/hooks/useProductDisplayData';
// import useProductCartActions from '~/hooks/useProductCartActions';
// import { useDebounce } from 'ahooks';
// import { useRouter } from 'next/navigation';
// import { getShippingInfo } from '~/utilities/shippingInfo';
// import { calculateBasePrice } from '~/utilities/basePriceCalculator';
// import { getAvailability, getAddToCartLabel, resolveAvailabilityAttrs } from '~/utilities/availability';
// import { createPortal } from 'react-dom';
// import CategoryVariantSelector from '~/components/elements/products/modules/CategoryVariantSelector';
// import {
//     BellIcon,
//     OutOfStockBadge,
// } from '~/components/elements/products/modules/ProductParts';

// const placeholderURL = '/static/img/products/rawento-product-placeholder.webp';

// const formatPriceDE = (value) => {
//     if (value === undefined || value === null || value === '' || value === '–') return '–';
//     const num = typeof value === 'number' ? value : Number(String(value).replace(',', '.'));
//     if (!Number.isFinite(num)) return '–';
//     return new Intl.NumberFormat('de-DE', {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//     }).format(num);
// };

// const normalizeShippingType = (raw) => {
//     const s = String(raw || '').trim().toLowerCase();
//     if (s === 'versand mit dhl paket') return 'Versand mit DHL Paket';
//     if (s === 'lieferung durch spedition') return 'Lieferung durch Spedition';
//     if (['digitaler versand', 'esd versand', 'esd'].includes(s)) return 'ESD Versand';
//     return raw || 'Kostenloser Versand';
// };

// const getShippingLinkText = (shippingType) => {
//     if (shippingType === 'Versand mit DHL Paket') return ' zzgl. Versand';
//     if (shippingType === 'Lieferung durch Spedition') return ' zzgl. Spedition';
//     if (shippingType === 'ESD Versand') return ' digitaler Versand';
//     return null;
// };

// const getSearchWords = (raw) =>
//     String(raw || '').trim().toLowerCase().split(/\s+/).filter(Boolean);

// const isFuzzyWord = (word) => word.length >= 5 && !/\d/.test(word);

// const maxTypos = (word) => (word.length >= 8 ? 2 : word.length >= 5 ? 1 : 0);

// const editDistance = (a, b) => {
//     const la = a.length;
//     const lb = b.length;
//     if (la === 0) return lb;
//     if (lb === 0) return la;
//     const d = Array.from({ length: la + 1 }, () => new Array(lb + 1).fill(0));
//     for (let i = 0; i <= la; i += 1) d[i][0] = i;
//     for (let j = 0; j <= lb; j += 1) d[0][j] = j;
//     for (let i = 1; i <= la; i += 1) {
//         for (let j = 1; j <= lb; j += 1) {
//             const cost = a[i - 1] === b[j - 1] ? 0 : 1;
//             d[i][j] = Math.min(
//                 d[i - 1][j] + 1,
//                 d[i][j - 1] + 1,
//                 d[i - 1][j - 1] + cost
//             );
//             if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
//                 d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
//             }
//         }
//     }
//     return d[la][lb];
// };

// const tokenize = (str) =>
//     String(str || '').toLowerCase().split(/[^a-z0-9äöüß]+/).filter(Boolean);

// const scoreWord = (word, title, sku) => {
//     if (title.includes(word) || sku.includes(word)) return { score: 100, exact: true };
//     if (!isFuzzyWord(word)) return { score: 0, exact: false };

//     const tokens = [...tokenize(title), ...tokenize(sku)];
//     let best = Infinity;
//     for (let i = 0; i < tokens.length; i += 1) {
//         const token = tokens[i];
//         let dist = editDistance(word, token);
//         if (token.length > word.length) {
//             dist = Math.min(dist, editDistance(word, token.slice(0, word.length)));
//         }
//         if (dist < best) best = dist;
//         if (best === 0) break;
//     }
//     if (best <= maxTypos(word)) return { score: 70 - best * 10, exact: false };
//     return { score: 0, exact: false };
// };

// const dropdownBorderColor = '#d9dbe0';
// const dropdownBorderStyle = `1px solid ${dropdownBorderColor}`;

// const resultsDropdownWidthStyle = {
//     width: 'clamp(560px, 50vw, 988px)',
//     maxWidth: 'calc(100vw - 32px)',
// };

// const discountBadgeStyle = {
//     borderRadius: '3px',
//     background: 'rgb(255, 255, 255)',
//     border: '1px solid rgb(250, 207, 207)',
//     display: 'inline-flex',
//     alignItems: 'center',
//     padding: '2px 6px',
//     width: 'fit-content',
//     fontSize: '15px',
//     lineHeight: '16px',
//     fontWeight: 500,
//     color: 'rgb(216, 34, 34)',
//     boxSizing: 'border-box',
//     letterSpacing: '0.4px',
//     whiteSpace: 'nowrap',
//     flexShrink: 0,
// };

// const closeBarStyle = {
//     display: 'flex',
//     justifyContent: 'flex-end',
//     alignItems: 'center',
//     width: '100%',
//     padding: '4px 12px 0 12px',
//     boxSizing: 'border-box',
// };

// const closeButtonStyle = {
//     border: 'none',
//     outline: 'none',
//     background: 'transparent',
//     cursor: 'pointer',
//     fontSize: '22px',
//     lineHeight: 1,
//     color: '#444',
//     width: '32px',
//     height: '32px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     borderRadius: '9999px',
//     flexShrink: 0,
//     padding: 0,
// };

// const productCardBorderGray = '#e4e6ea';

// const productCardStyle = {
//     marginRight: 0,
//     textDecoration: 'none',
//     padding: '8px',
//     backgroundColor: '#ffffff',
//     border: `1px solid ${productCardBorderGray}`,
//     borderRadius: '8px',
//     gap: '4px',
//     display: 'flex',
//     flexDirection: 'column',
//     height: 'auto',
//     position: 'relative',
//     minWidth: 0,
//     overflow: 'hidden',
//     boxSizing: 'border-box',
// };

// const productImageWrapStyle = {
//     backgroundColor: 'transparent',
//     borderRadius: '6px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     width: '100%',
//     height: '110px',
//     overflow: 'hidden',
// };

// const productsGridStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))',
//     gap: '20px',
//     width: '100%',
// };

// const SMALL_BOX_HEIGHT = 260;

// const POPULAR_SEARCHES = [
//     'Windows 11',
//     'Microsoft Office',
//     'Antivirus',
//     'Notebook',
//     'Monitor',
//     'Gaming PC',
//     'Tastatur',
//     'SSD',
//     'Grafikkarte',
//     'Router',
//     'Kopfhörer',
//     'Maus',
// ];

// const popularTitleStyle = {
//     fontSize: '14px',
//     fontWeight: 700,
//     color: '#2f3134',
//     letterSpacing: '0.4px',
//     margin: '0 0 12px 0',
// };

// const popularTagStyle = {
//     border: '1px solid transparent',
//     borderRadius: '9999px',
//     padding: '8px 16px',
//     fontSize: '14px',
//     lineHeight: '20px',
//     color: '#111111',
//     cursor: 'pointer',
//     whiteSpace: 'nowrap',
// };

// const rwSpinnerKeyframes = (
//     <style>{`
//         .rw-spinner {
//             border: 2px solid rgba(45, 70, 105, 0.15);
//             border-top-color: var(--rw-spinner-color, #2D4669);
//             border-radius: 50%;
//             display: block;
//             width: var(--rw-spinner-size, 20px);
//             height: var(--rw-spinner-size, 20px);
//             animation: rw-spinner-rotate 0.7s linear infinite;
//         }
//         @keyframes rw-spinner-rotate {
//             to { transform: rotate(360deg); }
//         }

//         .rw-variant-wrap {
//             height: auto;
//             min-height: 0;
//             max-height: none;
//             width: 100%;
//             box-sizing: border-box;
//             overflow: visible;
//             margin: 2px 0;
//         }

//         .rw-cart-row {
//             width: 100%;
//             max-width: 100%;
//             box-sizing: border-box;
//             display: flex;
//             justify-content: flex-end;
//             align-items: center;
//             margin-top: auto;
//             padding-top: 6px;
//             min-width: 0;
//         }
//         .rw-cart-btn {
//             display: inline-flex;
//             align-items: center;
//             justify-content: flex-end;
//             gap: 5px;
//             padding: 0;
//             border: 0;
//             background: transparent;
//             color: #111;
//             font-size: 12px;
//             font-weight: 700;
//             line-height: 1;
//             cursor: pointer;
//             white-space: nowrap;
//             align-self: flex-end;
//             max-width: 100%;
//             min-width: 0;
//         }
//         .rw-cart-btn:hover { color: #06c; }
//         .rw-cart-btn--success, .rw-cart-btn--success:hover { color: #0e813a; }
//         .rw-cart-btn__text { text-decoration: underline; overflow: hidden; text-overflow: ellipsis; flex-shrink: 1; min-width: 0; }
//         .rw-cart-btn--success .rw-cart-btn__text { text-decoration: none; flex-shrink: 1; }
//         .rw-cart-btn__icon { display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; }
//         .rw-cart-btn__icon svg { width: 20px; height: 15px; display: block; }
//         .rw-availability { align-self: flex-end; max-width: 100%; margin-top: 5px; }
//     `}</style>
// );

// const SpinnerIcon = ({ size = 20, color = '#2D4669' }) => (
//     <span
//         className="rw-spinner"
//         style={{ '--rw-spinner-size': `${size}px`, '--rw-spinner-color': color }}
//     />
// );

// const SearchProductCard = ({ product, apiBaseUrl, toggleSlideIn, onOverlayChange }) => {
//     const [selectedVariant, setSelectedVariant] = useState(null);

//     const activeSource = selectedVariant?.attributes || product.attributes;

//     const {
//         productId,
//         plainProductTitle,
//         numericPrice,
//         isAvailable,
//         hasStockInfo,
//     } = useProductDisplayData(product, selectedVariant);

//     const availability = useMemo(
//         () =>
//             getAvailability(
//                 resolveAvailabilityAttrs(
//                     product.attributes,
//                     selectedVariant?.attributes || null
//                 ),
//                 activeSource?.shippings?.data?.attributes ||
//                     product.attributes?.shippings?.data?.attributes ||
//                     null
//             ),
//         [activeSource, selectedVariant, product]
//     );
//     const canOrder = availability.status === 'preorder' ? true : isAvailable;
//     const addToCartLabel = getAddToCartLabel(availability);

//     const { handleAddToCart, openNotifyModal, notifyModal, notifySuccessMessage } = useProductCartActions({
//         productId,
//         productTitle: plainProductTitle,
//         productPrice: numericPrice,
//     });

//     const isNotifyModalOpen = Boolean(notifyModal);
//     useEffect(() => {
//         onOverlayChange?.(isNotifyModalOpen);
//         return () => onOverlayChange?.(false);
//     }, [isNotifyModalOpen, onOverlayChange]);

//     const productSlug = product.attributes?.slug || product.id;
//     const productTitle = activeSource?.title || product.attributes?.title || product.attributes?.sku || 'Produkt';

//     const imageUrl = activeSource?.base_image_thumbnail;
//     const finalImageSrc = imageUrl ? `${apiBaseUrl}/images/${imageUrl}` : placeholderURL;

//     const rawPrice = activeSource?.price;
//     const price = formatPriceDE(rawPrice);
//     const currentPrice = rawPrice != null ? Number(rawPrice) : null;

//     const lowest30d = activeSource?.lowestPrice30d ?? null;
//     const showReduction =
//         lowest30d !== null &&
//         currentPrice !== null &&
//         Number(lowest30d) > currentPrice;
//     const bestPrice30d = formatPriceDE(lowest30d);

//     const discountPercent = showReduction
//         ? (((Number(lowest30d) - currentPrice) / Number(lowest30d)) * 100).toFixed(0)
//         : null;

//     const taxRate = activeSource?.taxes?.data?.attributes?.tax_rate;
//     const taxAndShippingInfo = taxRate !== undefined && taxRate !== null ? 'inkl. MwSt.' : 'MwSt. nicht angegeben';

//     const rawShipping = activeSource?.shippings?.data?.attributes?.shipping_type;
//     const shippingType = normalizeShippingType(rawShipping);
//     const shippingLinkText = getShippingLinkText(shippingType);
//     const shouldShowShippingLink = shippingLinkText !== null;

//     const baseprice_product_amount = product.attributes?.baseprice_product_amount;
//     const baseprice_product_unit = product.attributes?.baseprice_product_unit;
//     const baseprice_reference_amount = product.attributes?.baseprice_reference_amount;
//     const baseprice_reference_unit = product.attributes?.baseprice_reference_unit;

//     const basePricePerUnit = calculateBasePrice(
//         rawPrice,
//         baseprice_product_amount,
//         baseprice_product_unit,
//         baseprice_reference_amount,
//         baseprice_reference_unit
//     );

//     const energyEfficiencyImage = activeSource?.energy_efficiencies?.data?.attributes?.energy_efficiency_image;
//     const energyEfficiencyLabelUrl = activeSource?.energy_efficiency_label
//         ? `${apiBaseUrl}/${activeSource.energy_efficiency_label}`
//         : null;
//     const energyEfficiencyDatasheetUrl = activeSource?.energy_efficiency_datasheet
//         ? `${apiBaseUrl}/${activeSource.energy_efficiency_datasheet}`
//         : null;

//     return (
//         <div style={productCardStyle}>
//             <a href={`/product/${productSlug}`} style={{ color: 'rgb(12, 25, 58)', textDecoration: 'none', display: 'block', position: 'relative' }}>
//                 <div style={productImageWrapStyle}>
//                     <img
//                         src={finalImageSrc}
//                         alt={productTitle}
//                         style={{ objectFit: 'contain', width: '110px', height: '96px', maxWidth: '100%', display: 'block', mixBlendMode: 'multiply' }}
//                         onError={(e) => { e.target.src = placeholderURL; }}
//                     />
//                 </div>
//                 {discountPercent !== null && (
//                     <div data-testid="product-tag" className="ps-product__discount-badge" style={{ ...discountBadgeStyle, position: 'absolute', top: '4px', left: '4px' }}>
//                         -{discountPercent}%
//                     </div>
//                 )}
//             </a>

//             <p style={{ lineHeight: '16px', fontWeight: '400', fontSize: '12px', width: '100%', height: '34px', WebkitLineClamp: 2, overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical', margin: '4px 0 0 0' }}>
//                 <Link href={`/product/${productSlug}`} style={{ color: 'rgb(12, 25, 58)', textDecoration: 'none', display: 'block' }}>
//                     {productTitle}
//                 </Link>
//             </p>

//             {energyEfficiencyImage && (
//                 <div style={{ display: 'flex', flexDirection: 'column', marginTop: '2px', width: '100%' }}>
//                     <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', gap: '4px', maxWidth: '100%' }}>
//                         {energyEfficiencyDatasheetUrl && (
//                             <div
//                                 onClick={() => window.open(energyEfficiencyDatasheetUrl, '_blank')}
//                                 style={{ cursor: 'pointer', color: '#0073e6', fontSize: '10px', fontWeight: 'bold', textDecoration: 'underline', whiteSpace: 'nowrap', flexShrink: 0 }}
//                             >
//                                 Datenblatt
//                             </div>
//                         )}
//                         <img
//                             src={`${apiBaseUrl}${energyEfficiencyImage}`}
//                             alt="Energy Efficiency"
//                             style={{ cursor: 'pointer', maxWidth: '35px', maxHeight: '18px', width: 'auto', height: 'auto', flexShrink: 1, minWidth: '25px', display: 'block' }}
//                             onClick={() => energyEfficiencyLabelUrl && window.open(energyEfficiencyLabelUrl, '_blank')}
//                         />
//                     </div>
//                 </div>
//             )}

//             <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginTop: '4px', width: '100%' }}>
//                 <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
//                     <div style={{ fontWeight: '700', fontSize: '14px', lineHeight: '20px', color: showReduction ? '#bf0000' : '#000000', margin: 0, whiteSpace: 'nowrap', flexShrink: 0 }}>
//                         {price}
//                         <sup style={{ fontSize: '0.6em', fontWeight: 500, marginLeft: '1px' }}>€</sup>
//                     </div>
//                     {showReduction && (
//                         <div style={{ fontSize: '12px', color: 'rgb(122, 117, 117)', fontWeight: '500', textDecoration: 'line-through', whiteSpace: 'nowrap', flexShrink: 0 }}>
//                             {bestPrice30d}
//                             <sup style={{ fontSize: '0.6em', fontWeight: 500, marginLeft: '1px' }}>€</sup>
//                         </div>
//                     )}
//                 </div>

//                 {basePricePerUnit && (
//                     <div style={{ marginTop: '0px' }}>
//                         <span style={{ fontSize: '10px', lineHeight: '14px', color: 'rgb(122, 117, 117)' }}>
//                             {basePricePerUnit}
//                             <sup style={{ fontSize: '0.6em', fontWeight: 500, marginLeft: '1px' }}>€</sup>
//                             {' '}/ 1 {baseprice_reference_unit}
//                         </span>
//                     </div>
//                 )}

//                 {showReduction && (
//                     <p style={{ fontSize: '10px', lineHeight: '14px', color: 'rgb(122, 117, 117)', margin: 0 }}>
//                         30 Tage Bestpreis: {bestPrice30d}
//                         <sup style={{ fontSize: '0.6em', fontWeight: 500, marginLeft: '1px' }}>€</sup>
//                     </p>
//                 )}
//             </div>

//             <div className="rw-variant-wrap">
//                 <CategoryVariantSelector product={product} onVariantChange={setSelectedVariant} />
//             </div>

//             <div style={{ marginTop: '2px' }}>
//                 <p style={{ color: 'rgb(80, 89, 113)', lineHeight: '15px', fontWeight: '400', fontSize: '11px', margin: 0 }}>
//                     {taxAndShippingInfo}
//                     {shouldShowShippingLink && (
//                         <span
//                             style={{ color: '#06c', cursor: 'pointer', fontSize: '11px' }}
//                             onClick={() => toggleSlideIn(shippingType)}
//                         >
//                             {shippingLinkText}
//                         </span>
//                     )}
//                 </p>
//             </div>

//             <div className="rw-cart-row">
//                 {canOrder ? (
//                     <button
//                         type="button"
//                         className="rw-cart-btn"
//                         aria-label={addToCartLabel}
//                         onClick={handleAddToCart}
//                     >
//                         <span className="rw-cart-btn__text">{addToCartLabel}</span>
//                         <span aria-hidden="true" className="rw-cart-btn__icon">
//                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 19" width="20" height="15" fill="none">
//                                 <g stroke="currentColor">
//                                     <path d="M1 1.5h4.2l4 8.8h10.4l3.8-8.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                                     <circle cx="10.4" cy="15.5" r="1.8" strokeWidth="1.6" />
//                                     <circle cx="20.2" cy="15.5" r="1.8" strokeWidth="1.6" />
//                                 </g>
//                             </svg>
//                         </span>
//                     </button>
//                 ) : (
//                     <button
//                         type="button"
//                         className={`rw-cart-btn${notifySuccessMessage ? ' rw-cart-btn--success' : ''}`}
//                         aria-label={notifySuccessMessage ? 'Wir informieren Sie, sobald das Produkt verfügbar ist.' : 'Informiere mich...'}
//                         title={notifySuccessMessage ? 'Wir informieren Sie, sobald das Produkt verfügbar ist.' : undefined}
//                         onClick={openNotifyModal}
//                     >
//                         <span aria-hidden="true" className="rw-cart-btn__icon">
//                             <BellIcon />
//                         </span>
//                         <span className="rw-cart-btn__text">
//                             {notifySuccessMessage ? '✓ Wir informieren Sie' : 'Informiere mich...'}
//                         </span>
//                     </button>
//                 )}
//             </div>

//             {hasStockInfo && !canOrder && (
//                 <div className="rw-availability">
//                     <OutOfStockBadge />
//                 </div>
//             )}

//             {notifyModal}
//         </div>
//     );
// };

// const SearchHeader = ({ onSearchToggle }) => {
//     const inputEl = useRef(null);
//     const dropdownRef = useRef(null);
//     const containerRef = useRef(null);
//     const overlayOpenRef = useRef(false);
//     const [keyword, setKeyword] = useState('');
//     const [isFocused, setIsFocused] = useState(false);
//     const [isDropdownClosed, setIsDropdownClosed] = useState(false);
//     const [isSlideInVisible, setSlideInVisible] = useState(false);
//     const [isSlideInAnimated, setSlideInAnimated] = useState(false);
//     const [currentShippingType, setCurrentShippingType] = useState('');
//     const { products, loading, getStrapiProducts, resetProducts, meta } = useGetProducts();
//     const keywordDebounce = useDebounce(keyword, { wait: 300 });
//     const router = useRouter();

//     useEffect(() => {
//         onSearchToggle?.((keyword !== '' && !isDropdownClosed) || isFocused);
//     }, [keyword, isFocused, isDropdownClosed, onSearchToggle]);

//     const containerHeight = 44;

//     useEffect(() => {
//         resetProducts();
//     }, [keyword, resetProducts]);

//     useEffect(() => {
//         if (isSlideInVisible) {
//             setSlideInAnimated(false);
//             setTimeout(() => setSlideInVisible(false), 300);
//         }
//     }, [keyword]);

//     function handleClearKeyword() {
//         setKeyword('');
//         setIsDropdownClosed(false);
//         inputEl.current?.focus();
//     }

//     const closeDropdown = useCallback(() => {
//         setIsDropdownClosed(true);
//         setIsFocused(false);
//         setSlideInAnimated(false);
//         setSlideInVisible(false);
//         inputEl.current?.blur();
//     }, []);

//     function handleSubmit(e) {
//         e.preventDefault();
//         closeDropdown();
//         router.push(`/search?keyword=${encodeURIComponent(keyword)}`);
//     }

//     function handlePopularClick(term) {
//         setKeyword('');
//         setIsFocused(false);
//         inputEl.current?.blur();
//         router.push(`/search?keyword=${encodeURIComponent(term)}`);
//     }

//     const handleOverlayChange = useCallback((open) => {
//         overlayOpenRef.current = Boolean(open);
//     }, []);

//     const handleClickOutside = useCallback((event) => {
//         if (overlayOpenRef.current) return;
//         if (containerRef.current && !containerRef.current.contains(event.target)) {
//             setKeyword('');
//             setIsFocused(false);
//             setIsDropdownClosed(false);
//         }
//     }, []);

//     useEffect(() => {
//         if (keyword.length > 0 || isFocused) {
//             document.addEventListener('mousedown', handleClickOutside);
//             return () => document.removeEventListener('mousedown', handleClickOutside);
//         }
//     }, [keyword.length, isFocused, handleClickOutside]);

//     const toggleSlideIn = useCallback((shippingType) => {
//         setCurrentShippingType(shippingType);
//         if (isSlideInVisible) {
//             setSlideInAnimated(false);
//             setTimeout(() => setSlideInVisible(false), 500);
//         } else {
//             setSlideInVisible(true);
//             requestAnimationFrame(() => {
//                 requestAnimationFrame(() => {
//                     setSlideInAnimated(true);
//                 });
//             });
//         }
//     }, [isSlideInVisible]);

//     useEffect(() => {
//         if (isSlideInVisible) {
//             document.body.style.overflow = 'hidden';
//         } else {
//             document.body.style.overflow = '';
//         }
//         const handleEscape = (event) => {
//             if (event.key === 'Escape' && isSlideInVisible) {
//                 toggleSlideIn(currentShippingType);
//             }
//         };
//         document.addEventListener('keydown', handleEscape);
//         return () => {
//             document.body.style.overflow = '';
//             document.removeEventListener('keydown', handleEscape);
//         };
//     }, [isSlideInVisible, currentShippingType, toggleSlideIn]);

//     const searchQuery = useMemo(() => {
//         if (keywordDebounce.trim().length > 2) {
//             const words = getSearchWords(keywordDebounce);
//             const hasFuzzy = words.some(isFuzzyWord);

//             const wordFilters = words.map((word) => {
//                 const orFilters = [
//                     { title: { $containsi: word } },
//                     { sku: { $containsi: word } },
//                 ];

//                 if (isFuzzyWord(word)) {
//                     const fragLength = Math.max(3, Math.ceil(word.length / 2));
//                     const head = word.slice(0, fragLength);
//                     const tail = word.slice(-fragLength);
//                     orFilters.push(
//                         { title: { $containsi: head } },
//                         { sku: { $containsi: head } },
//                         { title: { $containsi: tail } },
//                         { sku: { $containsi: tail } }
//                     );
//                 }

//                 return { $or: orFilters };
//             });

//             const query = {
//                 filters: {
//                     $and: [
//                         ...wordFilters,
//                         { visibility: { $eq: 'Katalog, Suche' } }
//                     ]
//                 },
//                 populate: {
//                     taxes: { fields: ['summary', 'tax_rate'] },
//                     shippings: true,
//                     product_categories: { fields: ['title', 'slug'] },
//                     product_typs: { fields: ['title', 'slug'] },
//                     product_brands: { fields: ['manufacturer_url'] },
//                     energy_efficiencies: { fields: ['energy_efficiency_class', 'energy_efficiency_image'] },
//                     product_variants: {
//                         populate: {
//                             facet_inputs: {
//                                 fields: ['title'],
//                                 populate: 'facets',
//                             },
//                             taxes: {
//                                 fields: ['summary', 'tax_rate'],
//                             },
//                             shippings: true,
//                             energy_efficiencies: {
//                                 fields: [
//                                     'energy_efficiency_class',
//                                     'energy_efficiency_image',
//                                 ],
//                             },
//                             product_typs: {
//                                 fields: ['title', 'slug'],
//                             },
//                         },
//                     },
//                 },
//                 sort: ['order:asc', 'title:asc'],
//                 pagination: { pageSize: hasFuzzy ? 100 : 40 },
//             };
//             return query;
//         }
//         return null;
//     }, [keywordDebounce]);

//     useEffect(() => {
//         if (searchQuery) {
//             getStrapiProducts(searchQuery, 'search');
//         }
//     }, [searchQuery, getStrapiProducts]);

//     const totalSearchResults = useMemo(() => {
//         if (loading || !meta?.pagination) return 0;
//         return meta.pagination.total || 0;
//     }, [meta?.pagination, loading]);

//     // Das Backend entscheidet, welche Produkte Treffer sind.
//     // Das Scoring sortiert nur noch, es filtert nichts mehr heraus.
//     const scoredResults = useMemo(() => {
//         if (loading || keyword.trim().length === 0) return [];
//         const words = getSearchWords(keyword);
//         if (words.length === 0) return [];

//         return (products || [])
//             .map((product, index) => {
//                 const title = (product.attributes?.title || '').toLowerCase();
//                 const sku = (product.attributes?.sku || '').toLowerCase();

//                 let total = 0;
//                 for (let i = 0; i < words.length; i += 1) {
//                     total += scoreWord(words[i], title, sku).score;
//                 }
//                 let score = total / words.length;

//                 const titleTokens = tokenize(title);
//                 if (title.startsWith(words[0])) score += 30;
//                 else if (titleTokens.includes(words[0])) score += 15;

//                 return { product, score, index };
//             })
//             .sort((a, b) => b.score - a.score || a.index - b.index)
//             .slice(0, 8);
//     }, [products, loading, keyword]);

//     const resultProducts = useMemo(
//         () => scoredResults.map(({ product }) => product),
//         [scoredResults]
//     );

//     const hasResults = resultProducts.length > 0;
//     const isTooShort = keyword.length > 0 && keyword.length < 3;
//     const isSearchPending = keyword.length >= 3 && keywordDebounce !== keyword;
//     const rawShowLoadingBox = keyword.length >= 3 && (loading || isSearchPending);
//     const rawShowNoResults = keyword.length >= 3 && !rawShowLoadingBox && !hasResults;

//     const [confirmedNoResults, setConfirmedNoResults] = useState(false);
//     useEffect(() => {
//         if (rawShowNoResults) {
//             const timer = setTimeout(() => setConfirmedNoResults(true), 250);
//             return () => clearTimeout(timer);
//         }
//         setConfirmedNoResults(false);
//         return undefined;
//     }, [rawShowNoResults, keywordDebounce]);

//     const showNoResults = confirmedNoResults;
//     const showLoadingBox = rawShowLoadingBox || (rawShowNoResults && !confirmedNoResults);
//     const showDropdown =
//         !isDropdownClosed &&
//         keyword.length > 0 &&
//         (showLoadingBox || hasResults || showNoResults || isTooShort);

//     const showPopular = isFocused && keyword.length === 0;

//     const shippingInfoText = useMemo(() => {
//         return getShippingInfo(currentShippingType);
//     }, [currentShippingType]);

//     const slideInPortal = isSlideInVisible && typeof window !== 'undefined'
//         ? createPortal(
//             <>
//                 <div
//                     className={`rw-slidein-overlay rw-slidein-overlay--top ${isSlideInAnimated ? 'open' : ''}`}
//                     onClick={() => toggleSlideIn(currentShippingType)}
//                 />
//                 <div className={`rw-slidein rw-slidein--top ${isSlideInAnimated ? 'open' : ''}`}>
//                     <div className="rw-slidein__header">
//                         <h3 className="rw-slidein__title">Versandinformationen</h3>
//                         <button
//                             type="button"
//                             className="rw-slidein__close"
//                             onClick={() => toggleSlideIn(currentShippingType)}
//                             aria-label="Schließen"
//                         >
//                             ×
//                         </button>
//                     </div>
//                     <div className="rw-slidein__body">{shippingInfoText}</div>
//                 </div>
//             </>,
//             document.body
//         )
//         : null;

//     const quickSearchBox = useMemo(() => {
//         if (!showDropdown) return null;

//         if (isTooShort) {
//             const remaining = 3 - keyword.length;
//             return (
//                 <div ref={dropdownRef} className="search-results-dropdown absolute z-[60000] top-full left-1/2 -translate-x-1/2 w-[50vw] max-w-md bg-white shadow-2xl rounded-xl mt-px text-center relative overflow-hidden" style={{ minHeight: `${SMALL_BOX_HEIGHT}px`, display: 'flex', flexDirection: 'column', border: dropdownBorderStyle }}>
//                     <div style={{ ...closeBarStyle, padding: '4px 0 0 0' }}>
//                         <button
//                             type="button"
//                             onClick={handleClearKeyword}
//                             style={closeButtonStyle}
//                             className="hover:bg-gray-100 transition-all duration-200"
//                         >
//                             ×
//                         </button>
//                     </div>

//                     <div className="px-6" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '28px' }}>
//                         <div style={{
//                             width: '48px',
//                             height: '48px',
//                             borderRadius: '50%',
//                             background: 'linear-gradient(135deg, #eef2f7 0%, #e4e9f0 100%)',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             margin: '0 auto 16px',
//                         }}>
//                             <i className="icon-magnifier" style={{ fontSize: '20px', color: '#2D4669' }} />
//                         </div>

//                         <p style={{
//                             fontSize: '14px',
//                             fontWeight: 600,
//                             color: '#2f3134',
//                             margin: '0 0 6px',
//                         }}>
//                             Noch {remaining === 1 ? 'ein Zeichen' : `${remaining} Zeichen`}
//                         </p>
//                         <p style={{
//                             fontSize: '13px',
//                             color: '#8a8f98',
//                             margin: 0,
//                             lineHeight: 1.5,
//                         }}>
//                             Gib mindestens 3 Zeichen ein, um die Suche zu starten.
//                         </p>

//                         <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', marginTop: '18px' }}>
//                             {[0, 1, 2].map((i) => (
//                                 <div
//                                     key={i}
//                                     style={{
//                                         width: '7px',
//                                         height: '7px',
//                                         borderRadius: '50%',
//                                         background: i < keyword.length ? '#2D4669' : '#e4e9f0',
//                                         transition: 'background 0.25s ease',
//                                     }}
//                                 />
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             );
//         }

//         if (showLoadingBox) {
//             return (
//                 <div ref={dropdownRef} className="search-results-dropdown absolute z-[60000] top-full left-1/2 -translate-x-1/2 w-[50vw] max-w-md bg-white shadow-2xl rounded-xl mt-px text-center relative overflow-hidden" style={{ minHeight: `${SMALL_BOX_HEIGHT}px`, display: 'flex', flexDirection: 'column', border: dropdownBorderStyle }}>
//                     <div style={{ ...closeBarStyle, padding: '4px 0 0 0' }}>
//                         <button
//                             type="button"
//                             onClick={handleClearKeyword}
//                             style={closeButtonStyle}
//                             className="hover:bg-gray-100 transition-all duration-200"
//                         >
//                             ×
//                         </button>
//                     </div>

//                     <div className="px-6" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '28px' }}>
//                         <div style={{
//                             width: '48px',
//                             height: '48px',
//                             borderRadius: '50%',
//                             background: 'linear-gradient(135deg, #eef2f7 0%, #e4e9f0 100%)',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             margin: '0 auto 16px',
//                         }}>
//                             <SpinnerIcon size={20} color="#2D4669" />
//                         </div>
//                         <p style={{
//                             fontSize: '14px',
//                             fontWeight: 600,
//                             color: '#2f3134',
//                             margin: '0 0 6px',
//                         }}>
//                             Suchen
//                         </p>
//                         <p style={{
//                             fontSize: '13px',
//                             color: '#8a8f98',
//                             margin: 0,
//                             lineHeight: 1.5,
//                         }}>
//                             Wir durchsuchen unser Sortiment für dich.
//                         </p>
//                     </div>
//                 </div>
//             );
//         }

//         if (hasResults) {
//             return (
//                 <>
//                     <div ref={dropdownRef} className="search-results-dropdown absolute z-[60000] top-full left-1/2 -translate-x-1/2 bg-white rounded-[16px] overflow-hidden cursor-auto flex flex-col relative" style={{ border: dropdownBorderStyle, ...resultsDropdownWidthStyle }}>

//                         <div style={closeBarStyle}>
//                             <button
//                                 type="button"
//                                 onClick={handleClearKeyword}
//                                 style={closeButtonStyle}
//                                 className="hover:bg-gray-100 transition-all duration-200"
//                             >
//                                 ×
//                             </button>
//                         </div>

//                         <div className="scrollbar-thin overflow-y-auto p-2 max-h-[calc(100vh-130px)]">
//                             <div style={{ paddingTop: '8px', padding: '8px 16px 16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                                 <div style={productsGridStyle}>
//                                     {resultProducts.slice(0, 8).map((product) => (
//                                         <SearchProductCard
//                                             key={product.id}
//                                             product={product}
//                                             apiBaseUrl={process.env.NEXT_PUBLIC_FRONTEND_URL || 'http://localhost:1337'}
//                                             toggleSlideIn={toggleSlideIn}
//                                             onOverlayChange={handleOverlayChange}
//                                         />
//                                     ))}
//                                 </div>
//                             </div>
//                         </div>

//                         <div style={{ padding: '12px 16px', borderTop: '1px solid rgb(236, 237, 240)', backgroundColor: 'rgb(248, 250, 252)' }}>
//                             <Link
//                                 href={`/search?keyword=${encodeURIComponent(keyword)}`}
//                                 onClick={closeDropdown}
//                                 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '600', fontSize: '14px', padding: '12px 20px', backgroundColor: '#2D4669', color: 'white', textDecoration: 'none', width: '100%', height: '44px', borderRadius: '8px' }}
//                             >
//                                 {totalSearchResults > 0
//                                     ? `Alle ${totalSearchResults.toLocaleString('de-DE')} Ergebnisse anzeigen`
//                                     : `Zur Suche: "${keyword}"`}
//                             </Link>
//                         </div>
//                     </div>

//                     {slideInPortal}
//                 </>
//             );
//         }

//         if (showNoResults) {
//             return (
//                 <div ref={dropdownRef} className="search-results-dropdown absolute z-[60000] top-full left-1/2 -translate-x-1/2 w-[50vw] max-w-md bg-white shadow-2xl rounded-xl mt-px text-center relative overflow-hidden" style={{ minHeight: `${SMALL_BOX_HEIGHT}px`, display: 'flex', flexDirection: 'column', border: dropdownBorderStyle }}>
//                     <div style={{ ...closeBarStyle, padding: '4px 0 0 0' }}>
//                         <button
//                             type="button"
//                             onClick={handleClearKeyword}
//                             style={closeButtonStyle}
//                             className="hover:bg-gray-100 transition-all duration-200"
//                         >
//                             ×
//                         </button>
//                     </div>

//                     <div className="px-6" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '28px' }}>
//                         <div style={{
//                             width: '48px',
//                             height: '48px',
//                             borderRadius: '50%',
//                             background: 'linear-gradient(135deg, #eef2f7 0%, #e4e9f0 100%)',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             margin: '0 auto 16px',
//                         }}>
//                             <i className="icon-magnifier" style={{ fontSize: '20px', color: '#2D4669' }} />
//                         </div>

//                         <p style={{
//                             fontSize: '14px',
//                             fontWeight: 600,
//                             color: '#2f3134',
//                             margin: '0 0 16px',
//                         }}>
//                             Keine Ergebnisse für "<strong>{keyword}</strong>" gefunden.
//                         </p>

//                         <Link
//                             href={`/search?keyword=${encodeURIComponent(keyword)}`}
//                             onClick={closeDropdown}
//                             style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: '600', fontSize: '14px', padding: '12px 24px', backgroundColor: '#2D4669', color: 'white', textDecoration: 'none', borderRadius: '8px' }}
//                         >
//                             Zur Suchergebnisseite
//                         </Link>
//                     </div>
//                 </div>
//             );
//         }

//         return null;
//     }, [resultProducts, keyword, showLoadingBox, handleClearKeyword, isSlideInVisible, currentShippingType, shippingInfoText, totalSearchResults, showDropdown, hasResults, showNoResults, isTooShort, toggleSlideIn, handleOverlayChange, slideInPortal, closeDropdown]);

//     return (
//         <div ref={containerRef} className="ps-search--mobile relative" style={{ height: `${containerHeight}px`, zIndex: isFocused || (keyword !== '' && !isDropdownClosed) ? 60001 : 'auto', position: 'relative' }}>
//             {rwSpinnerKeyframes}
//             <form className="ps-form--search-mobile h-full" action="/" method="get" onSubmit={handleSubmit}>
//                 <div className="form-group--nest h-full flex items-center">
//                     <input
//                         ref={inputEl}
//                         className="form-control flex-1 h-10"
//                         type="text"
//                         value={keyword}
//                         placeholder="Suchen nach Marken, Artikeln & mehr..."
//                         onFocus={() => {
//                             setIsFocused(true);
//                             setIsDropdownClosed(false);
//                         }}
//                         onChange={(e) => {
//                             setKeyword(e.target.value);
//                             setIsDropdownClosed(false);
//                         }}
//                     />
//                     <button type="submit" aria-label="Suchen">
//                         <i className="icon-magnifier" />
//                     </button>
//                 </div>
//             </form>
//             {loading && !isDropdownClosed && (
//                 <span
//                     className="ps-form__action absolute right-12 top-1/2 -translate-y-1/2"
//                     style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
//                 >
//                     <SpinnerIcon size={16} color="#2D4669" />
//                 </span>
//             )}
//             {quickSearchBox}

//             {showPopular && (
//                 <div
//                     className="search-popular-dropdown absolute top-full left-0 w-full bg-white"
//                     style={{
//                         padding: '16px 20px 20px',
//                         border: dropdownBorderStyle,
//                         borderRadius: '16px',
//                         boxShadow: '0 12px 32px rgba(0,0,0,0.12)',
//                         zIndex: 60000,
//                     }}
//                 >
//                     <p style={popularTitleStyle}>Beliebte Suchanfragen</p>
//                     <ul style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', listStyle: 'none', margin: 0, padding: 0 }}>
//                         {POPULAR_SEARCHES.map((term) => (
//                             <li key={term}>
//                                 <button
//                                     type="button"
//                                     onClick={() => handlePopularClick(term)}
//                                     className="bg-[#f4f5fa] hover:bg-[#e6e8f1] transition-colors duration-150"
//                                     style={popularTagStyle}
//                                 >
//                                     {term}
//                                 </button>
//                             </li>
//                         ))}
//                     </ul>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default SearchHeader;


'use client';

import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import Link from 'next/link';
import useGetProducts from '~/hooks/useSearchProducts';
import useProductDisplayData from '~/hooks/useProductDisplayData';
import useProductCartActions from '~/hooks/useProductCartActions';
import { useDebounce } from 'ahooks';
import { useRouter } from 'next/navigation';
import { getShippingInfo } from '~/utilities/shippingInfo';
import { calculateBasePrice } from '~/utilities/basePriceCalculator';
import { getAvailability, getAddToCartLabel, resolveAvailabilityAttrs } from '~/utilities/availability';
import { createPortal } from 'react-dom';
import CategoryVariantSelector from '~/components/elements/products/modules/CategoryVariantSelector';
import {
    BellIcon,
    OutOfStockBadge,
} from '~/components/elements/products/modules/ProductParts';

const placeholderURL = '/static/img/products/rawento-product-placeholder.webp';

const formatPriceDE = (value) => {
    if (value === undefined || value === null || value === '' || value === '–') return '–';
    const num = typeof value === 'number' ? value : Number(String(value).replace(',', '.'));
    if (!Number.isFinite(num)) return '–';
    return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(num);
};

const normalizeShippingType = (raw) => {
    const s = String(raw || '').trim().toLowerCase();
    if (s === 'versand mit dhl paket') return 'Versand mit DHL Paket';
    if (s === 'lieferung durch spedition') return 'Lieferung durch Spedition';
    if (['digitaler versand', 'esd versand', 'esd'].includes(s)) return 'ESD Versand';
    return raw || 'Kostenloser Versand';
};

const getShippingLinkText = (shippingType) => {
    if (shippingType === 'Versand mit DHL Paket') return ' zzgl. Versand';
    if (shippingType === 'Lieferung durch Spedition') return ' zzgl. Spedition';
    if (shippingType === 'ESD Versand') return ' digitaler Versand';
    return null;
};

const getSearchWords = (raw) =>
    String(raw || '').trim().toLowerCase().split(/\s+/).filter(Boolean);

const isFuzzyWord = (word) => word.length >= 5 && !/\d/.test(word);

const maxTypos = (word) => (word.length >= 8 ? 2 : word.length >= 5 ? 1 : 0);

const editDistance = (a, b) => {
    const la = a.length;
    const lb = b.length;
    if (la === 0) return lb;
    if (lb === 0) return la;
    const d = Array.from({ length: la + 1 }, () => new Array(lb + 1).fill(0));
    for (let i = 0; i <= la; i += 1) d[i][0] = i;
    for (let j = 0; j <= lb; j += 1) d[0][j] = j;
    for (let i = 1; i <= la; i += 1) {
        for (let j = 1; j <= lb; j += 1) {
            const cost = a[i - 1] === b[j - 1] ? 0 : 1;
            d[i][j] = Math.min(
                d[i - 1][j] + 1,
                d[i][j - 1] + 1,
                d[i - 1][j - 1] + cost
            );
            if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
                d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
            }
        }
    }
    return d[la][lb];
};

const tokenize = (str) =>
    String(str || '').toLowerCase().split(/[^a-z0-9äöüß]+/).filter(Boolean);

const scoreWord = (word, title, sku) => {
    if (title.includes(word) || sku.includes(word)) return { score: 100, exact: true };
    if (!isFuzzyWord(word)) return { score: 0, exact: false };

    const tokens = [...tokenize(title), ...tokenize(sku)];
    let best = Infinity;
    for (let i = 0; i < tokens.length; i += 1) {
        const token = tokens[i];
        let dist = editDistance(word, token);
        if (token.length > word.length) {
            dist = Math.min(dist, editDistance(word, token.slice(0, word.length)));
        }
        if (dist < best) best = dist;
        if (best === 0) break;
    }
    if (best <= maxTypos(word)) return { score: 70 - best * 10, exact: false };
    return { score: 0, exact: false };
};

const dropdownBorderColor = '#d9dbe0';
const dropdownBorderStyle = `1px solid ${dropdownBorderColor}`;

const resultsDropdownWidthStyle = {
    width: 'clamp(560px, 50vw, 988px)',
    maxWidth: 'calc(100vw - 32px)',
};

const discountBadgeStyle = {
    borderRadius: '3px',
    background: 'rgb(255, 255, 255)',
    border: '1px solid rgb(250, 207, 207)',
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 6px',
    width: 'fit-content',
    fontSize: '15px',
    lineHeight: '16px',
    fontWeight: 500,
    color: 'rgb(216, 34, 34)',
    boxSizing: 'border-box',
    letterSpacing: '0.4px',
    whiteSpace: 'nowrap',
    flexShrink: 0,
};

const closeBarStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    padding: '4px 12px 0 12px',
    boxSizing: 'border-box',
};

const closeButtonStyle = {
    border: 'none',
    outline: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontSize: '22px',
    lineHeight: 1,
    color: '#444',
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '9999px',
    flexShrink: 0,
    padding: 0,
};

const productCardBorderGray = '#e4e6ea';

const productCardStyle = {
    marginRight: 0,
    textDecoration: 'none',
    padding: '8px',
    backgroundColor: '#ffffff',
    border: `1px solid ${productCardBorderGray}`,
    borderRadius: '8px',
    gap: '4px',
    display: 'flex',
    flexDirection: 'column',
    height: 'auto',
    position: 'relative',
    minWidth: 0,
    overflow: 'hidden',
    boxSizing: 'border-box',
};

const productImageWrapStyle = {
    backgroundColor: 'transparent',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '110px',
    overflow: 'hidden',
};

const GRID_MIN_CARD_WIDTH = 140;
const GRID_GAP = 20;
const GRID_MIN_COLUMNS = 1;
const GRID_MAX_COLUMNS = 4;
const GRID_ROWS = 2;

const productsGridStyle = {
    display: 'grid',
    gap: `${GRID_GAP}px`,
    width: '100%',
};

const SMALL_BOX_HEIGHT = 260;

const POPULAR_SEARCHES = [
    'Windows 11',
    'Microsoft Office',
    'Antivirus',
    'Notebook',
    'Monitor',
    'Gaming PC',
    'Tastatur',
    'SSD',
    'Grafikkarte',
    'Router',
    'Kopfhörer',
    'Maus',
];

const popularTitleStyle = {
    fontSize: '14px',
    fontWeight: 700,
    color: '#2f3134',
    letterSpacing: '0.4px',
    margin: '0 0 12px 0',
};

const popularTagStyle = {
    border: '1px solid transparent',
    borderRadius: '9999px',
    padding: '8px 16px',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#111111',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
};

const rwSpinnerKeyframes = (
    <style>{`
        .rw-spinner {
            border: 2px solid rgba(45, 70, 105, 0.15);
            border-top-color: var(--rw-spinner-color, #2D4669);
            border-radius: 50%;
            display: block;
            width: var(--rw-spinner-size, 20px);
            height: var(--rw-spinner-size, 20px);
            animation: rw-spinner-rotate 0.7s linear infinite;
        }
        @keyframes rw-spinner-rotate {
            to { transform: rotate(360deg); }
        }

        .rw-variant-wrap {
            height: auto;
            min-height: 0;
            max-height: none;
            width: 100%;
            box-sizing: border-box;
            overflow: visible;
            margin: 2px 0;
        }

        .rw-cart-row {
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-top: auto;
            padding-top: 6px;
            min-width: 0;
        }
        .rw-cart-btn {
            display: inline-flex;
            align-items: center;
            justify-content: flex-end;
            gap: 5px;
            padding: 0;
            border: 0;
            background: transparent;
            color: #111;
            font-size: 12px;
            font-weight: 700;
            line-height: 1;
            cursor: pointer;
            white-space: nowrap;
            align-self: flex-end;
            max-width: 100%;
            min-width: 0;
        }
        .rw-cart-btn:hover { color: #06c; }
        .rw-cart-btn--success, .rw-cart-btn--success:hover { color: #0e813a; }
        .rw-cart-btn__text { text-decoration: underline; overflow: hidden; text-overflow: ellipsis; flex-shrink: 1; min-width: 0; }
        .rw-cart-btn--success .rw-cart-btn__text { text-decoration: none; flex-shrink: 1; }
        .rw-cart-btn__icon { display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; }
        .rw-cart-btn__icon svg { width: 20px; height: 15px; display: block; }
        .rw-availability { align-self: flex-end; max-width: 100%; margin-top: 5px; }
    `}</style>
);

const SpinnerIcon = ({ size = 20, color = '#2D4669' }) => (
    <span
        className="rw-spinner"
        style={{ '--rw-spinner-size': `${size}px`, '--rw-spinner-color': color }}
    />
);

const SearchProductCard = ({ product, apiBaseUrl, toggleSlideIn, onOverlayChange }) => {
    const [selectedVariant, setSelectedVariant] = useState(null);

    const activeSource = selectedVariant?.attributes || product.attributes;

    const {
        productId,
        plainProductTitle,
        numericPrice,
        isAvailable,
        hasStockInfo,
    } = useProductDisplayData(product, selectedVariant);

    const availability = useMemo(
        () =>
            getAvailability(
                resolveAvailabilityAttrs(
                    product.attributes,
                    selectedVariant?.attributes || null
                ),
                activeSource?.shippings?.data?.attributes ||
                    product.attributes?.shippings?.data?.attributes ||
                    null
            ),
        [activeSource, selectedVariant, product]
    );
    const canOrder = availability.status === 'preorder' ? true : isAvailable;
    const addToCartLabel = getAddToCartLabel(availability);

    const { handleAddToCart, openNotifyModal, notifyModal, notifySuccessMessage } = useProductCartActions({
        productId,
        productTitle: plainProductTitle,
        productPrice: numericPrice,
    });

    const isNotifyModalOpen = Boolean(notifyModal);
    useEffect(() => {
        onOverlayChange?.(isNotifyModalOpen);
        return () => onOverlayChange?.(false);
    }, [isNotifyModalOpen, onOverlayChange]);

    const productSlug = product.attributes?.slug || product.id;
    const productTitle = activeSource?.title || product.attributes?.title || product.attributes?.sku || 'Produkt';

    const imageUrl = activeSource?.base_image_thumbnail;
    const finalImageSrc = imageUrl ? `${apiBaseUrl}/images/${imageUrl}` : placeholderURL;

    const rawPrice = activeSource?.price;
    const price = formatPriceDE(rawPrice);
    const currentPrice = rawPrice != null ? Number(rawPrice) : null;

    const lowest30d = activeSource?.lowestPrice30d ?? null;
    const showReduction =
        lowest30d !== null &&
        currentPrice !== null &&
        Number(lowest30d) > currentPrice;
    const bestPrice30d = formatPriceDE(lowest30d);

    const discountPercent = showReduction
        ? (((Number(lowest30d) - currentPrice) / Number(lowest30d)) * 100).toFixed(0)
        : null;

    const taxRate = activeSource?.taxes?.data?.attributes?.tax_rate;
    const taxAndShippingInfo = taxRate !== undefined && taxRate !== null ? 'inkl. MwSt.' : 'MwSt. nicht angegeben';

    const rawShipping = activeSource?.shippings?.data?.attributes?.shipping_type;
    const shippingType = normalizeShippingType(rawShipping);
    const shippingLinkText = getShippingLinkText(shippingType);
    const shouldShowShippingLink = shippingLinkText !== null;

    const baseprice_product_amount = product.attributes?.baseprice_product_amount;
    const baseprice_product_unit = product.attributes?.baseprice_product_unit;
    const baseprice_reference_amount = product.attributes?.baseprice_reference_amount;
    const baseprice_reference_unit = product.attributes?.baseprice_reference_unit;

    const basePricePerUnit = calculateBasePrice(
        rawPrice,
        baseprice_product_amount,
        baseprice_product_unit,
        baseprice_reference_amount,
        baseprice_reference_unit
    );

    const energyEfficiencyImage = activeSource?.energy_efficiencies?.data?.attributes?.energy_efficiency_image;
    const energyEfficiencyLabelUrl = activeSource?.energy_efficiency_label
        ? `${apiBaseUrl}/${activeSource.energy_efficiency_label}`
        : null;
    const energyEfficiencyDatasheetUrl = activeSource?.energy_efficiency_datasheet
        ? `${apiBaseUrl}/${activeSource.energy_efficiency_datasheet}`
        : null;

    return (
        <div style={productCardStyle}>
            <a href={`/product/${productSlug}`} style={{ color: 'rgb(12, 25, 58)', textDecoration: 'none', display: 'block', position: 'relative' }}>
                <div style={productImageWrapStyle}>
                    <img
                        src={finalImageSrc}
                        alt={productTitle}
                        style={{ objectFit: 'contain', width: '110px', height: '96px', maxWidth: '100%', display: 'block', mixBlendMode: 'multiply' }}
                        onError={(e) => { e.target.src = placeholderURL; }}
                    />
                </div>
                {discountPercent !== null && (
                    <div data-testid="product-tag" className="ps-product__discount-badge" style={{ ...discountBadgeStyle, position: 'absolute', top: '4px', left: '4px' }}>
                        -{discountPercent}%
                    </div>
                )}
            </a>

            <p style={{ lineHeight: '16px', fontWeight: '400', fontSize: '12px', width: '100%', height: '34px', WebkitLineClamp: 2, overflow: 'hidden', display: '-webkit-box', WebkitBoxOrient: 'vertical', margin: '4px 0 0 0' }}>
                <Link href={`/product/${productSlug}`} style={{ color: 'rgb(12, 25, 58)', textDecoration: 'none', display: 'block' }}>
                    {productTitle}
                </Link>
            </p>

            {energyEfficiencyImage && (
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: '2px', width: '100%' }}>
                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', gap: '4px', maxWidth: '100%' }}>
                        {energyEfficiencyDatasheetUrl && (
                            <div
                                onClick={() => window.open(energyEfficiencyDatasheetUrl, '_blank')}
                                style={{ cursor: 'pointer', color: '#0073e6', fontSize: '10px', fontWeight: 'bold', textDecoration: 'underline', whiteSpace: 'nowrap', flexShrink: 0 }}
                            >
                                Datenblatt
                            </div>
                        )}
                        <img
                            src={`${apiBaseUrl}${energyEfficiencyImage}`}
                            alt="Energy Efficiency"
                            style={{ cursor: 'pointer', maxWidth: '35px', maxHeight: '18px', width: 'auto', height: 'auto', flexShrink: 1, minWidth: '25px', display: 'block' }}
                            onClick={() => energyEfficiencyLabelUrl && window.open(energyEfficiencyLabelUrl, '_blank')}
                        />
                    </div>
                </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginTop: '4px', width: '100%' }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <div style={{ fontWeight: '700', fontSize: '14px', lineHeight: '20px', color: showReduction ? '#bf0000' : '#000000', margin: 0, whiteSpace: 'nowrap', flexShrink: 0 }}>
                        {price}
                        <sup style={{ fontSize: '0.6em', fontWeight: 500, marginLeft: '1px' }}>€</sup>
                    </div>
                    {showReduction && (
                        <div style={{ fontSize: '12px', color: 'rgb(122, 117, 117)', fontWeight: '500', textDecoration: 'line-through', whiteSpace: 'nowrap', flexShrink: 0 }}>
                            {bestPrice30d}
                            <sup style={{ fontSize: '0.6em', fontWeight: 500, marginLeft: '1px' }}>€</sup>
                        </div>
                    )}
                </div>

                {basePricePerUnit && (
                    <div style={{ marginTop: '0px' }}>
                        <span style={{ fontSize: '10px', lineHeight: '14px', color: 'rgb(122, 117, 117)' }}>
                            {basePricePerUnit}
                            <sup style={{ fontSize: '0.6em', fontWeight: 500, marginLeft: '1px' }}>€</sup>
                            {' '}/ 1 {baseprice_reference_unit}
                        </span>
                    </div>
                )}

                {showReduction && (
                    <p style={{ fontSize: '10px', lineHeight: '14px', color: 'rgb(122, 117, 117)', margin: 0 }}>
                        30 Tage Bestpreis: {bestPrice30d}
                        <sup style={{ fontSize: '0.6em', fontWeight: 500, marginLeft: '1px' }}>€</sup>
                    </p>
                )}
            </div>

            <div className="rw-variant-wrap">
                <CategoryVariantSelector product={product} onVariantChange={setSelectedVariant} />
            </div>

            <div style={{ marginTop: '2px' }}>
                <p style={{ color: 'rgb(80, 89, 113)', lineHeight: '15px', fontWeight: '400', fontSize: '11px', margin: 0 }}>
                    {taxAndShippingInfo}
                    {shouldShowShippingLink && (
                        <span
                            style={{ color: '#06c', cursor: 'pointer', fontSize: '11px' }}
                            onClick={() => toggleSlideIn(shippingType)}
                        >
                            {shippingLinkText}
                        </span>
                    )}
                </p>
            </div>

            <div className="rw-cart-row">
                {canOrder ? (
                    <button
                        type="button"
                        className="rw-cart-btn"
                        aria-label={addToCartLabel}
                        onClick={handleAddToCart}
                    >
                        <span className="rw-cart-btn__text">{addToCartLabel}</span>
                        <span aria-hidden="true" className="rw-cart-btn__icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 19" width="20" height="15" fill="none">
                                <g stroke="currentColor">
                                    <path d="M1 1.5h4.2l4 8.8h10.4l3.8-8.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <circle cx="10.4" cy="15.5" r="1.8" strokeWidth="1.6" />
                                    <circle cx="20.2" cy="15.5" r="1.8" strokeWidth="1.6" />
                                </g>
                            </svg>
                        </span>
                    </button>
                ) : (
                    <button
                        type="button"
                        className={`rw-cart-btn${notifySuccessMessage ? ' rw-cart-btn--success' : ''}`}
                        aria-label={notifySuccessMessage ? 'Wir informieren Sie, sobald das Produkt verfügbar ist.' : 'Informiere mich...'}
                        title={notifySuccessMessage ? 'Wir informieren Sie, sobald das Produkt verfügbar ist.' : undefined}
                        onClick={openNotifyModal}
                    >
                        <span aria-hidden="true" className="rw-cart-btn__icon">
                            <BellIcon />
                        </span>
                        <span className="rw-cart-btn__text">
                            {notifySuccessMessage ? '✓ Wir informieren Sie' : 'Informiere mich...'}
                        </span>
                    </button>
                )}
            </div>

            {hasStockInfo && !canOrder && (
                <div className="rw-availability">
                    <OutOfStockBadge />
                </div>
            )}

            {notifyModal}
        </div>
    );
};

const SearchHeader = ({ onSearchToggle }) => {
    const inputEl = useRef(null);
    const dropdownRef = useRef(null);
    const containerRef = useRef(null);
    const overlayOpenRef = useRef(false);
    const [keyword, setKeyword] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [isDropdownClosed, setIsDropdownClosed] = useState(false);
    const [isSlideInVisible, setSlideInVisible] = useState(false);
    const [isSlideInAnimated, setSlideInAnimated] = useState(false);
    const [currentShippingType, setCurrentShippingType] = useState('');
    const { products, loading, getStrapiProducts, resetProducts, meta } = useGetProducts();
    const keywordDebounce = useDebounce(keyword, { wait: 300 });
    const router = useRouter();
    const [gridColumns, setGridColumns] = useState(GRID_MAX_COLUMNS);
    const gridObserverRef = useRef(null);
    const visibleCount = gridColumns * GRID_ROWS;

    const gridRefCallback = useCallback((node) => {
        if (gridObserverRef.current) {
            gridObserverRef.current.disconnect();
            gridObserverRef.current = null;
        }
        if (!node) return;
        const update = () => {
            const width = node.clientWidth;
            const columns = Math.floor((width + GRID_GAP) / (GRID_MIN_CARD_WIDTH + GRID_GAP));
            setGridColumns(Math.min(GRID_MAX_COLUMNS, Math.max(GRID_MIN_COLUMNS, columns)));
        };
        update();
        if (typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(update);
            observer.observe(node);
            gridObserverRef.current = observer;
        }
    }, []);

    useEffect(() => {
        onSearchToggle?.((keyword !== '' && !isDropdownClosed) || isFocused);
    }, [keyword, isFocused, isDropdownClosed, onSearchToggle]);

    const containerHeight = 44;

    useEffect(() => {
        resetProducts();
    }, [keyword, resetProducts]);

    useEffect(() => {
        if (isSlideInVisible) {
            setSlideInAnimated(false);
            setTimeout(() => setSlideInVisible(false), 300);
        }
    }, [keyword]);

    function handleClearKeyword() {
        setKeyword('');
        setIsDropdownClosed(false);
        inputEl.current?.focus();
    }

    const closeDropdown = useCallback(() => {
        setIsDropdownClosed(true);
        setIsFocused(false);
        setSlideInAnimated(false);
        setSlideInVisible(false);
        inputEl.current?.blur();
    }, []);

    function handleSubmit(e) {
        e.preventDefault();
        closeDropdown();
        router.push(`/search?keyword=${encodeURIComponent(keyword)}`);
    }

    function handlePopularClick(term) {
        setKeyword('');
        setIsFocused(false);
        inputEl.current?.blur();
        router.push(`/search?keyword=${encodeURIComponent(term)}`);
    }

    const handleOverlayChange = useCallback((open) => {
        overlayOpenRef.current = Boolean(open);
    }, []);

    const handleClickOutside = useCallback((event) => {
        if (overlayOpenRef.current) return;
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setKeyword('');
            setIsFocused(false);
            setIsDropdownClosed(false);
        }
    }, []);

    useEffect(() => {
        if (keyword.length > 0 || isFocused) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [keyword.length, isFocused, handleClickOutside]);

    const toggleSlideIn = useCallback((shippingType) => {
        setCurrentShippingType(shippingType);
        if (isSlideInVisible) {
            setSlideInAnimated(false);
            setTimeout(() => setSlideInVisible(false), 500);
        } else {
            setSlideInVisible(true);
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setSlideInAnimated(true);
                });
            });
        }
    }, [isSlideInVisible]);

    useEffect(() => {
        if (isSlideInVisible) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        const handleEscape = (event) => {
            if (event.key === 'Escape' && isSlideInVisible) {
                toggleSlideIn(currentShippingType);
            }
        };
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.body.style.overflow = '';
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isSlideInVisible, currentShippingType, toggleSlideIn]);

    const searchQuery = useMemo(() => {
        if (keywordDebounce.trim().length > 2) {
            const words = getSearchWords(keywordDebounce);
            const hasFuzzy = words.some(isFuzzyWord);

            const wordFilters = words.map((word) => {
                const orFilters = [
                    { title: { $containsi: word } },
                    { sku: { $containsi: word } },
                ];

                if (isFuzzyWord(word)) {
                    const fragLength = Math.max(3, Math.ceil(word.length / 2));
                    const head = word.slice(0, fragLength);
                    const tail = word.slice(-fragLength);
                    orFilters.push(
                        { title: { $containsi: head } },
                        { sku: { $containsi: head } },
                        { title: { $containsi: tail } },
                        { sku: { $containsi: tail } }
                    );
                }

                return { $or: orFilters };
            });

            const query = {
                filters: {
                    $and: [
                        ...wordFilters,
                        { visibility: { $eq: 'Katalog, Suche' } }
                    ]
                },
                populate: {
                    taxes: { fields: ['summary', 'tax_rate'] },
                    shippings: true,
                    product_categories: { fields: ['title', 'slug'] },
                    product_typs: { fields: ['title', 'slug'] },
                    product_brands: { fields: ['manufacturer_url'] },
                    energy_efficiencies: { fields: ['energy_efficiency_class', 'energy_efficiency_image'] },
                    product_variants: {
                        populate: {
                            facet_inputs: {
                                fields: ['title'],
                                populate: 'facets',
                            },
                            taxes: {
                                fields: ['summary', 'tax_rate'],
                            },
                            shippings: true,
                            energy_efficiencies: {
                                fields: [
                                    'energy_efficiency_class',
                                    'energy_efficiency_image',
                                ],
                            },
                            product_typs: {
                                fields: ['title', 'slug'],
                            },
                        },
                    },
                },
                sort: ['order:asc', 'title:asc'],
                pagination: { pageSize: hasFuzzy ? 100 : 40 },
            };
            return query;
        }
        return null;
    }, [keywordDebounce]);

    useEffect(() => {
        if (searchQuery) {
            getStrapiProducts(searchQuery, 'search');
        }
    }, [searchQuery, getStrapiProducts]);

    const totalSearchResults = useMemo(() => {
        if (loading || !meta?.pagination) return 0;
        return meta.pagination.total || 0;
    }, [meta?.pagination, loading]);

    // Das Backend entscheidet, welche Produkte Treffer sind.
    // Das Scoring sortiert nur noch, es filtert nichts mehr heraus.
    const scoredResults = useMemo(() => {
        if (loading || keyword.trim().length === 0) return [];
        const words = getSearchWords(keyword);
        if (words.length === 0) return [];

        return (products || [])
            .map((product, index) => {
                const title = (product.attributes?.title || '').toLowerCase();
                const sku = (product.attributes?.sku || '').toLowerCase();

                let total = 0;
                for (let i = 0; i < words.length; i += 1) {
                    total += scoreWord(words[i], title, sku).score;
                }
                let score = total / words.length;

                const titleTokens = tokenize(title);
                if (title.startsWith(words[0])) score += 30;
                else if (titleTokens.includes(words[0])) score += 15;

                return { product, score, index };
            })
            .sort((a, b) => b.score - a.score || a.index - b.index)
            .slice(0, visibleCount);
    }, [products, loading, keyword, visibleCount]);

    const resultProducts = useMemo(
        () => scoredResults.map(({ product }) => product),
        [scoredResults]
    );

    const hasResults = resultProducts.length > 0;
    const isTooShort = keyword.length > 0 && keyword.length < 3;
    const isSearchPending = keyword.length >= 3 && keywordDebounce !== keyword;
    const rawShowLoadingBox = keyword.length >= 3 && (loading || isSearchPending);
    const rawShowNoResults = keyword.length >= 3 && !rawShowLoadingBox && !hasResults;

    const [confirmedNoResults, setConfirmedNoResults] = useState(false);
    useEffect(() => {
        if (rawShowNoResults) {
            const timer = setTimeout(() => setConfirmedNoResults(true), 250);
            return () => clearTimeout(timer);
        }
        setConfirmedNoResults(false);
        return undefined;
    }, [rawShowNoResults, keywordDebounce]);

    const showNoResults = confirmedNoResults;
    const showLoadingBox = rawShowLoadingBox || (rawShowNoResults && !confirmedNoResults);
    const showDropdown =
        !isDropdownClosed &&
        keyword.length > 0 &&
        (showLoadingBox || hasResults || showNoResults || isTooShort);

    const showPopular = isFocused && keyword.length === 0;

    const shippingInfoText = useMemo(() => {
        return getShippingInfo(currentShippingType);
    }, [currentShippingType]);

    const slideInPortal = isSlideInVisible && typeof window !== 'undefined'
        ? createPortal(
            <>
                <div
                    className={`rw-slidein-overlay rw-slidein-overlay--top ${isSlideInAnimated ? 'open' : ''}`}
                    onClick={() => toggleSlideIn(currentShippingType)}
                />
                <div className={`rw-slidein rw-slidein--top ${isSlideInAnimated ? 'open' : ''}`}>
                    <div className="rw-slidein__header">
                        <h3 className="rw-slidein__title">Versandinformationen</h3>
                        <button
                            type="button"
                            className="rw-slidein__close"
                            onClick={() => toggleSlideIn(currentShippingType)}
                            aria-label="Schließen"
                        >
                            ×
                        </button>
                    </div>
                    <div className="rw-slidein__body">{shippingInfoText}</div>
                </div>
            </>,
            document.body
        )
        : null;

    const quickSearchBox = useMemo(() => {
        if (!showDropdown) return null;

        if (isTooShort) {
            const remaining = 3 - keyword.length;
            return (
                <div ref={dropdownRef} className="search-results-dropdown absolute z-[60000] top-full left-1/2 -translate-x-1/2 w-[50vw] max-w-md bg-white shadow-2xl rounded-xl mt-px text-center relative overflow-hidden" style={{ minHeight: `${SMALL_BOX_HEIGHT}px`, display: 'flex', flexDirection: 'column', border: dropdownBorderStyle }}>
                    <div style={{ ...closeBarStyle, padding: '4px 0 0 0' }}>
                        <button
                            type="button"
                            onClick={handleClearKeyword}
                            style={closeButtonStyle}
                            className="hover:bg-gray-100 transition-all duration-200"
                        >
                            ×
                        </button>
                    </div>

                    <div className="px-6" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '28px' }}>
                        <div style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '50%',
                            background: 'linear-gradient(135deg, #eef2f7 0%, #e4e9f0 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 16px',
                        }}>
                            <i className="icon-magnifier" style={{ fontSize: '20px', color: '#2D4669' }} />
                        </div>

                        <p style={{
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#2f3134',
                            margin: '0 0 6px',
                        }}>
                            Noch {remaining === 1 ? 'ein Zeichen' : `${remaining} Zeichen`}
                        </p>
                        <p style={{
                            fontSize: '13px',
                            color: '#8a8f98',
                            margin: 0,
                            lineHeight: 1.5,
                        }}>
                            Gib mindestens 3 Zeichen ein, um die Suche zu starten.
                        </p>

                        <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', marginTop: '18px' }}>
                            {[0, 1, 2].map((i) => (
                                <div
                                    key={i}
                                    style={{
                                        width: '7px',
                                        height: '7px',
                                        borderRadius: '50%',
                                        background: i < keyword.length ? '#2D4669' : '#e4e9f0',
                                        transition: 'background 0.25s ease',
                                    }}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            );
        }

        if (showLoadingBox) {
            return (
                <div ref={dropdownRef} className="search-results-dropdown absolute z-[60000] top-full left-1/2 -translate-x-1/2 w-[50vw] max-w-md bg-white shadow-2xl rounded-xl mt-px text-center relative overflow-hidden" style={{ minHeight: `${SMALL_BOX_HEIGHT}px`, display: 'flex', flexDirection: 'column', border: dropdownBorderStyle }}>
                    <div style={{ ...closeBarStyle, padding: '4px 0 0 0' }}>
                        <button
                            type="button"
                            onClick={handleClearKeyword}
                            style={closeButtonStyle}
                            className="hover:bg-gray-100 transition-all duration-200"
                        >
                            ×
                        </button>
                    </div>

                    <div className="px-6" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '28px' }}>
                        <div style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '50%',
                            background: 'linear-gradient(135deg, #eef2f7 0%, #e4e9f0 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 16px',
                        }}>
                            <SpinnerIcon size={20} color="#2D4669" />
                        </div>
                        <p style={{
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#2f3134',
                            margin: '0 0 6px',
                        }}>
                            Suchen
                        </p>
                        <p style={{
                            fontSize: '13px',
                            color: '#8a8f98',
                            margin: 0,
                            lineHeight: 1.5,
                        }}>
                            Wir durchsuchen unser Sortiment für dich.
                        </p>
                    </div>
                </div>
            );
        }

        if (hasResults) {
            return (
                <>
                    <div ref={dropdownRef} className="search-results-dropdown absolute z-[60000] top-full left-1/2 -translate-x-1/2 bg-white rounded-[16px] overflow-hidden cursor-auto flex flex-col relative" style={{ border: dropdownBorderStyle, ...resultsDropdownWidthStyle }}>

                        <div style={closeBarStyle}>
                            <button
                                type="button"
                                onClick={handleClearKeyword}
                                style={closeButtonStyle}
                                className="hover:bg-gray-100 transition-all duration-200"
                            >
                                ×
                            </button>
                        </div>

                        <div className="scrollbar-thin overflow-y-auto p-2 max-h-[calc(100vh-130px)]">
                            <div style={{ paddingTop: '8px', padding: '8px 16px 16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <div ref={gridRefCallback} style={{ ...productsGridStyle, gridTemplateColumns: `repeat(${gridColumns}, minmax(0, 1fr))` }}>
                                    {resultProducts.slice(0, visibleCount).map((product) => (
                                        <SearchProductCard
                                            key={product.id}
                                            product={product}
                                            apiBaseUrl={process.env.NEXT_PUBLIC_FRONTEND_URL || 'http://localhost:1337'}
                                            toggleSlideIn={toggleSlideIn}
                                            onOverlayChange={handleOverlayChange}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div style={{ padding: '12px 16px', borderTop: '1px solid rgb(236, 237, 240)', backgroundColor: 'rgb(248, 250, 252)' }}>
                            <Link
                                href={`/search?keyword=${encodeURIComponent(keyword)}`}
                                onClick={closeDropdown}
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '600', fontSize: '14px', padding: '12px 20px', backgroundColor: '#2D4669', color: 'white', textDecoration: 'none', width: '100%', height: '44px', borderRadius: '8px' }}
                            >
                                {totalSearchResults > 0
                                    ? `Alle ${totalSearchResults.toLocaleString('de-DE')} Ergebnisse anzeigen`
                                    : `Zur Suche: "${keyword}"`}
                            </Link>
                        </div>
                    </div>

                    {slideInPortal}
                </>
            );
        }

        if (showNoResults) {
            return (
                <div ref={dropdownRef} className="search-results-dropdown absolute z-[60000] top-full left-1/2 -translate-x-1/2 w-[50vw] max-w-md bg-white shadow-2xl rounded-xl mt-px text-center relative overflow-hidden" style={{ minHeight: `${SMALL_BOX_HEIGHT}px`, display: 'flex', flexDirection: 'column', border: dropdownBorderStyle }}>
                    <div style={{ ...closeBarStyle, padding: '4px 0 0 0' }}>
                        <button
                            type="button"
                            onClick={handleClearKeyword}
                            style={closeButtonStyle}
                            className="hover:bg-gray-100 transition-all duration-200"
                        >
                            ×
                        </button>
                    </div>

                    <div className="px-6" style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '28px' }}>
                        <div style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '50%',
                            background: 'linear-gradient(135deg, #eef2f7 0%, #e4e9f0 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 16px',
                        }}>
                            <i className="icon-magnifier" style={{ fontSize: '20px', color: '#2D4669' }} />
                        </div>

                        <p style={{
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#2f3134',
                            margin: '0 0 16px',
                        }}>
                            Keine Ergebnisse für "<strong>{keyword}</strong>" gefunden.
                        </p>

                        <Link
                            href={`/search?keyword=${encodeURIComponent(keyword)}`}
                            onClick={closeDropdown}
                            style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: '600', fontSize: '14px', padding: '12px 24px', backgroundColor: '#2D4669', color: 'white', textDecoration: 'none', borderRadius: '8px' }}
                        >
                            Zur Suchergebnisseite
                        </Link>
                    </div>
                </div>
            );
        }

        return null;
    }, [resultProducts, keyword, showLoadingBox, handleClearKeyword, isSlideInVisible, currentShippingType, shippingInfoText, totalSearchResults, showDropdown, hasResults, showNoResults, isTooShort, toggleSlideIn, handleOverlayChange, slideInPortal, closeDropdown, gridColumns, gridRefCallback, visibleCount]);

    return (
        <div ref={containerRef} className="ps-search--mobile relative" style={{ height: `${containerHeight}px`, zIndex: isFocused || (keyword !== '' && !isDropdownClosed) ? 60001 : 'auto', position: 'relative' }}>
            {rwSpinnerKeyframes}
            <form className="ps-form--search-mobile h-full" action="/" method="get" onSubmit={handleSubmit}>
                <div className="form-group--nest h-full flex items-center">
                    <input
                        ref={inputEl}
                        className="form-control flex-1 h-10"
                        type="text"
                        value={keyword}
                        placeholder="Suchen nach Marken, Artikeln & mehr..."
                        onFocus={() => {
                            setIsFocused(true);
                            setIsDropdownClosed(false);
                        }}
                        onChange={(e) => {
                            setKeyword(e.target.value);
                            setIsDropdownClosed(false);
                        }}
                    />
                    <button type="submit" aria-label="Suchen">
                        <i className="icon-magnifier" />
                    </button>
                </div>
            </form>
            {loading && !isDropdownClosed && (
                <span
                    className="ps-form__action absolute right-12 top-1/2 -translate-y-1/2"
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                    <SpinnerIcon size={16} color="#2D4669" />
                </span>
            )}
            {quickSearchBox}

            {showPopular && (
                <div
                    className="search-popular-dropdown absolute top-full left-0 w-full bg-white"
                    style={{
                        padding: '16px 20px 20px',
                        border: dropdownBorderStyle,
                        borderRadius: '16px',
                        boxShadow: '0 12px 32px rgba(0,0,0,0.12)',
                        zIndex: 60000,
                    }}
                >
                    <p style={popularTitleStyle}>Beliebte Suchanfragen</p>
                    <ul style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', listStyle: 'none', margin: 0, padding: 0 }}>
                        {POPULAR_SEARCHES.map((term) => (
                            <li key={term}>
                                <button
                                    type="button"
                                    onClick={() => handlePopularClick(term)}
                                    className="bg-[#f4f5fa] hover:bg-[#e6e8f1] transition-colors duration-150"
                                    style={popularTagStyle}
                                >
                                    {term}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default SearchHeader;